"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[1186],{

/***/ 36209:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "R": () => (/* reexport */ PARTNER)
});

;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/constants/partner.ts
const PARTNER = {
  MMT: "mmt",
  GI: "gi",
  TRIPMONEY: "tripmoney",
  UNKNOWN: "unknown",
  MYPARTNER: "mypartner",
  MYBIZ: "mybiz"
};
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/constants/index.ts


/***/ }),

/***/ 3345:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Ml": () => (/* binding */ LOCAL_LANDING_BENEFITS),
/* harmony export */   "l5": () => (/* binding */ LOCAL_TERMS_AND_CONDITIONS),
/* harmony export */   "zF": () => (/* binding */ LOCAL_QnA_INFO)
/* harmony export */ });
/* unused harmony exports LOCAL_FOOTER_INFO, LOCAL_CONTENT_BLOCK_INFO */
// NOTE: This file consists of data which are hardcoded at FE now but will bw consumed later from BE and will be removed later
const LOCAL_FOOTER_INFO = [{
  links: [{
    title: "International Flights",
    url: "https://www.makemytrip.com/international-flights/"
  }, {
    title: "Hotels",
    url: "https://www.makemytrip.com/hotels/"
  }, {
    title: "International Hotels",
    url: "https://www.makemytrip.com/hotels-international/"
  }, {
    title: "Holiday Packages",
    url: "https://www.makemytrip.com/holidays-india/"
  }, {
    title: "International Holiday Packages",
    url: "https://www.makemytrip.com/holidays-international/"
  }, {
    title: "Travel Insurance",
    url: "https://www.makemytrip.com/insurance"
  }, {
    title: "Book Bus Ticket",
    url: "https://www.makemytrip.com/bus-tickets/"
  }, {
    title: "Book Train Ticket",
    url: "https://www.makemytrip.com/railways/"
  }, {
    title: "Cab Booking",
    url: "https://www.makemytrip.com/cabs/"
  }, {
    title: "MICE",
    url: "https://www.makemytrip.com/mice"
  }, {
    title: "myBiz",
    url: "https://mybiz.makemytrip.com/"
  }, {
    title: "myPartner",
    url: "https://mypartner.makemytrip.com/"
  }, {
    title: "Gift Card",
    url: "https://www.makemytrip.com/gift-cards/"
  }, {
    title: "MakeMyTrip UAE",
    url: "https://apps.apple.com/ae/app/makemytrip-travel-booking-app/id530488359"
  }],
  title: "Our Product",
  type: "section"
}, {
  links: [{
    title: "Dubai Currency",
    url: "https://www.makemytrip.com/tripmoney/currency/uae-dirham"
  }, {
    title: "Kuwait Currency",
    url: "https://www.makemytrip.com/tripmoney/currency/kuwaiti-dinar"
  }, {
    title: "Qatar Currency",
    url: "https://www.makemytrip.com/tripmoney/currency/qatari-riyal"
  }, {
    title: "Russian Currency",
    url: "https://www.makemytrip.com/tripmoney/currency/russian-ruble"
  }, {
    title: "Indonesia Currency",
    url: "https://www.makemytrip.com/tripmoney/currency/indonesian-rupiah"
  }, {
    title: "Malaysia Currency",
    url: "https://www.makemytrip.com/tripmoney/currency/malaysian-ringgit"
  }, {
    title: "United Kingdom",
    url: "- UK Currency   https://www.makemytrip.com/tripmoney/currency/pound"
  }, {
    title: "Canada Currency",
    url: "https://www.makemytrip.com/tripmoney/currency/canadian-dollar"
  }, {
    title: "China Currency",
    url: "https://www.makemytrip.com/tripmoney/currency/chinese-yuan-renminbi"
  }, {
    title: "Japan Currency",
    url: "https://www.makemytrip.com/tripmoney/currency/japanese-yen"
  }, {
    title: "United States",
    url: "- US Currency   https://www.makemytrip.com/tripmoney/currency/us-dollar"
  }, {
    title: "Saudi Arabia Currency",
    url: "https://www.makemytrip.com/tripmoney/currency/saudi-arabian-riyal"
  }, {
    title: "Singapore Currency",
    url: "https://www.makemytrip.com/tripmoney/currency/singapore-dollar"
  }, {
    title: "Thailand Currency",
    url: "https://www.makemytrip.com/tripmoney/currency/thai-baht"
  }, {
    title: "Germany Currency",
    url: "https://www.makemytrip.com/tripmoney/currency/euro"
  }, {
    title: "Oman Currency",
    url: "https://www.makemytrip.com/tripmoney/currency/omani-rial"
  }, {
    title: "Sri lanka Currency",
    url: "https://www.makemytrip.com/tripmoney/currency/sri-lankan-rupee"
  }, {
    title: "Ukraine Currency",
    url: "https://www.makemytrip.com/tripmoney/currency/ukrainian-hryvnia"
  }, {
    title: "Australlia Currency",
    url: "https://www.makemytrip.com/tripmoney/currency/australian-dollar"
  }, {
    title: "bahrain Currency",
    url: "https://www.makemytrip.com/tripmoney/currency/bahraini-dinar"
  }, {
    title: "Switzerland  Currency",
    url: "https://www.makemytrip.com/tripmoney/currency/swiss-franc"
  }],
  title: "Top Currency",
  type: "section"
}, {
  links: [{
    title: "Currency Exchange In Bangalore",
    url: "https://www.makemytrip.com/tripmoney/currency-exchange-in-bangalore"
  }, {
    title: "Currency Exchange In Delhi",
    url: "https://www.makemytrip.com/tripmoney/currency-exchange-in-delhi"
  }, {
    title: "Currency Exchange In Noida",
    url: "https://www.makemytrip.com/tripmoney/currency-exchange-in-noida"
  }, {
    title: "Currency Exchange In Gurgaon",
    url: "https://www.makemytrip.com/tripmoney/currency-exchange-in-gurgaon"
  }, {
    title: "Currency Exchange In Hyderabad",
    url: "https://www.makemytrip.com/tripmoney/currency-exchange-in-hyderabad"
  }, {
    title: "Currency Exchange In Pune",
    url: "https://www.makemytrip.com/tripmoney/currency-exchange-in-pune"
  }, {
    title: "Currency Exchange In Kolkata",
    url: "https://www.makemytrip.com/tripmoney/currency-exchange-in-kolkata"
  }, {
    title: "Currency Exchange In Mumbai",
    url: "https://www.makemytrip.com/tripmoney/currency-exchange-in-mumbai"
  }, {
    title: "Currency Exchange In Ahmedabad",
    url: "https://www.makemytrip.com/tripmoney/currency-exchange-in-ahemadabad"
  }, {
    title: "Currency Exchange In Chennai",
    url: "https://www.makemytrip.com/tripmoney/currency-exchange-in-chennai"
  }, {
    title: "Currency Exchange In Jaipur",
    url: "https://www.makemytrip.com/tripmoney/currency-exchange-in-jaipur"
  }, {
    title: "Currency Exchange In Chandigarh",
    url: "https://www.makemytrip.com/tripmoney/currency-exchange-in-chandigarh"
  }, {
    title: "Currency Exchange In Lucknow",
    url: "https://www.makemytrip.com/tripmoney/currency-exchange-in-lucknow"
  }, {
    title: "Currency Exchange In Vijayawada",
    url: "https://www.makemytrip.com/tripmoney/currency-exchange-in-vijayawada"
  }, {
    title: "Currency Exchange In Coimbatore",
    url: "https://www.makemytrip.com/tripmoney/currency-exchange-in-coimbatore"
  }, {
    title: "Currency Exchange In Vadodara",
    url: "https://www.makemytrip.com/tripmoney/currency-exchange-in-vadodara"
  }, {
    title: "Currency Exchange In Surat",
    url: "https://www.makemytrip.com/tripmoney/currency-exchange-in-surat"
  }, {
    title: "Currency Exchange In Thane",
    url: "https://www.makemytrip.com/tripmoney/currency-exchange-in-thane"
  }, {
    title: "Currency Exchange In Guwahati",
    url: "https://www.makemytrip.com/tripmoney/currency-exchange-in-guwahati"
  }, {
    title: "Currency Exchange In Bhopal",
    url: "https://www.makemytrip.com/tripmoney/currency-exchange-in-bhopal"
  }, {
    title: "Currency Exchange In Faridabad",
    url: "https://www.makemytrip.com/tripmoney/currency-exchange-in-faridabad"
  }, {
    title: "Currency Exchange In Patna",
    url: "https://www.makemytrip.com/tripmoney/currency-exchange-in-patna"
  }],
  title: "Currency Exchange in City",
  type: "section"
}, {
  items: [{
    links: [{
      imageurl: "https://tripmoneycmsimgak.mmtcdn.com/img/twitter_Icon_760f145ad2.png",
      type: "image-link",
      url: "https://insurance.makemytrip.com/insurance?startDate=1692697767\u0026endDate=1692784167\u0026travellers=1#"
    }, {
      imageurl: "https://tripmoneycmsimgak.mmtcdn.com/img/fb_Icon_8eab71f726.png",
      type: "image-link",
      url: "https://www.facebook.com/tripmoneymmt/"
    }, {
      imageurl: "https://tripmoneycmsimgak.mmtcdn.com/img/Linkedin_Icon_fec59ba5c7.png",
      type: "image-link",
      url: "https://www.linkedin.com/company/trip-money"
    }],
    type: "social-links"
  }, {
    type: "copyright",
    value: "\u0026copy; 2025 Makemytrip Pvt. Ltd. \nCountry, India"
  }],
  type: "footnote"
}];
const LOCAL_QnA_INFO = [{
  ques: "How to buy travel insurance online with MakeMyTrip?",
  info: "Buying travel insurance is simple on MakeMyTrip. All you need to do first is to download our app on your Android or iOS device or simply use your computer. On the app, tap on insurance section. Choose your preferred coverage plan and add it to your package. You can review benefits and coverage details before confirming. Complete your booking and your travel insurance policy details will be sent to your email instantly."
}, {
  ques: "How to find the best travel insurance plan for my trip?",
  info: "MakeMyTrip offers multiple travel insurance plans, tailored to your destination and trip duration. Use the filters on our platform to select based on coverage amount, medical benefits, baggage protection, or adventure activity coverage. You can compare plans side by side, and view full policy details before making a choice."
}, {
  ques: "How to file a travel insurance claim with MakeMyTrip?",
  info: "Filing a travel insurance claim is hassle-free with MakeMyTrip. For TATA AIG policies, you can notify your claim by sending an SMS, calling the 24x7 helpline, or emailing the claims department. Gather all necessary documents like your claim form, travel tickets, medical records, and receipts. Submit them to the Tata AIG claims team using the provided address or email. The insurance company will review your claim and documents, and any further steps or requirements will be shared with you. Claims are settled within 30 days after submission of all required paperwork. Always check your policy document for the detailed checklist and claim guidance."
}, {
  ques: "Where can I find detailed coverage and exclusions for my travel insurance?",
  info: "All coverage details, inclusions, and exclusions for MakeMyTrip travel insurance plans are displayed on the policy information page before checkout. Click “View Details” next to any plan to see full coverage, claims process, and exclusions. After purchase, your policy document and certificate will be emailed to you, or accessible through your Manage Booking section for future reference."
}];
const LOCAL_CONTENT_BLOCK_INFO = [{
  heading: "How to buy travel insurance online with MakeMyTrip?",
  description: "Buying travel insurance is simple on MakeMyTrip. Follow these steps:<ul><li>Download our app on your Android or iOS device or simply use your computer</li><li>On the app, tap on insurance section</li><li>Choose your preferred coverage plan and add it to your package</li><li>Review benefits and coverage details before confirming</li><li>Complete your booking and your travel insurance policy details will be sent to your email instantly</li></ul>"
}, {
  heading: "How to find the best travel insurance plan for my trip?",
  description: "MakeMyTrip offers multiple travel insurance plans, tailored to your destination and trip duration. Here's how to find the best plan:<ul><li>Use the filters on our platform to select based on coverage amount</li><li>Consider medical benefits, baggage protection, or adventure activity coverage</li><li>Compare plans side by side</li><li>View full policy details before making a choice</li></ul>"
}, {
  heading: "How to file a travel insurance claim with MakeMyTrip?",
  description: "Filing a travel insurance claim is hassle-free with MakeMyTrip. For TATA AIG policies, follow these steps:<ul><li>Notify your claim by sending an SMS, calling the 24x7 helpline, or emailing the claims department</li><li>Gather all necessary documents like your claim form, travel tickets, medical records, and receipts</li><li>Submit them to the Tata AIG claims team using the provided address or email</li><li>The insurance company will review your claim and documents, and any further steps or requirements will be shared with you</li><li>Claims are settled within 30 days after submission of all required paperwork</li><li>Always check your policy document for the detailed checklist and claim guidance</li></ul>"
}, {
  heading: "Where can I find detailed coverage and exclusions for my travel insurance?",
  description: "All coverage details, inclusions, and exclusions for MakeMyTrip travel insurance plans are displayed on the policy information page before checkout. Click 'View Details' next to any plan to see full coverage, claims process, and exclusions. After purchase, your policy document and certificate will be emailed to you, or accessible through your Manage Booking section for future reference."
}, {
  heading: "How to file a travel insurance claim with MakeMyTrip?",
  description: "Filing a travel insurance claim is hassle-free with MakeMyTrip. For TATA AIG policies, you can notify your claim by sending an SMS, calling the 24x7 helpline, or emailing the claims department. Gather all necessary documents like your claim form, travel tickets, medical records, and receipts. Submit them to the Tata AIG claims team using the provided address or email. The insurance company will review your claim and documents, and any further steps or requirements will be shared with you. Claims are settled within 30 days after submission of all required paperwork. Always check your policy document for the detailed checklist and claim guidance."
}, {
  heading: "Where can I find detailed coverage and exclusions for my travel insurance?",
  description: "All coverage details, inclusions, and exclusions for MakeMyTrip travel insurance plans are displayed on the policy information page before checkout. Click “View Details” next to any plan to see full coverage, claims process, and exclusions. After purchase, your policy document and certificate will be emailed to you, or accessible through your Manage Booking section for future reference."
}, {
  heading: "How to file a travel insurance claim with MakeMyTrip?",
  description: "Filing a travel insurance claim is hassle-free with MakeMyTrip. For TATA AIG policies, you can notify your claim by sending an SMS, calling the 24x7 helpline, or emailing the claims department. Gather all necessary documents like your claim form, travel tickets, medical records, and receipts. Submit them to the Tata AIG claims team using the provided address or email. The insurance company will review your claim and documents, and any further steps or requirements will be shared with you. Claims are settled within 30 days after submission of all required paperwork. Always check your policy document for the detailed checklist and claim guidance."
}, {
  heading: "Where can I find detailed coverage and exclusions for my travel insurance?",
  description: "All coverage details, inclusions, and exclusions for MakeMyTrip travel insurance plans are displayed on the policy information page before checkout. Click “View Details” next to any plan to see full coverage, claims process, and exclusions. After purchase, your policy document and certificate will be emailed to you, or accessible through your Manage Booking section for future reference."
}];
const LOCAL_TERMS_AND_CONDITIONS = {
  heading: "DISCLAIMER",
  body: `MMT has integrated with Symbo India Insurance Broking Private Limited having its insurance broking license number and validity: CA0599 / Valid up to 25th September 2025, to list Symbo’s insurance products for sale through the platform. Travel Agent Partners may purchase these insurance products through the Symbo’s dedicated page for its end users.<br/><br/>
  The Travel Agent Partner acknowledges and agrees that the purchase of the insurance products is made directly from Symbo, at their sole discretion. Therefore, the relationship for the purchase of the insurance products is strictly between the Travel Agent Partner and Symbo. MMT shall not be held responsible for any sale of the insurance products made through the platform.<br/><br/>
  Furthermore, the Travel Agent Partner understands that MMT is neither soliciting the sale of Symbo’s insurance products nor making any payments to Symbo in connection with these sales.<br/><br/>
  All insurance certificates resulting from the sale of insurance products through the platform shall be issued in accordance with the applicable laws. Symbo will be solely responsible for addressing any grievances arising from such sale of insurance products.`
};
const LOCAL_LANDING_BENEFITS = [{
  icon: "https://tripmoneycmsimgak.mmtcdn.com/img/Frame_2147223348_3x_1_dd9dbf9d95.png",
  title: "No KYC"
}, {
  icon: "https://tripmoneycmsimgak.mmtcdn.com/img/Frame_2147223348_3x_2_ca6d4d0383.png",
  title: "Use myCash to buy"
}, {
  icon: "https://tripmoneycmsimgak.mmtcdn.com/img/Frame_2147223348_3x_2fdd1619e6.png",
  title: "Pay only net amount" // subtitle: "Pay only net amount",

}];

/***/ }),

/***/ 71040:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);



const ArrowRight = ({
  width,
  height
}) => {
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
    width: `${width}px`,
    height: `${height}px`,
    viewBox: "0 0 22 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "data-test-id": "ArrowRight",
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M1 6.86518L21 6.86182L1 6.86518Z",
      fill: "var(--tm-accent-color)"
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
      d: "M1 6.86518L21 6.86182",
      stroke: "var(--tm-accent-color)",
      "stroke-width": "2",
      "stroke-linecap": "round"
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
      d: "M14.8595 13L20.2086 7.65621C20.5731 7.29196 20.5731 6.70132 20.2075 6.33707L14.8595 1",
      stroke: "var(--tm-accent-color)",
      "stroke-width": "2",
      "stroke-linecap": "round"
    })]
  });
};

/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (ArrowRight);

/***/ }),

/***/ 2638:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "T": () => (/* binding */ CloseIcon)
/* harmony export */ });
/* harmony import */ var _opt_jenkins_workspace_TripMoney_Node_16_CDN_Docker_Submit_GitHub_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(95235);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2784);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(52322);


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_opt_jenkins_workspace_TripMoney_Node_16_CDN_Docker_Submit_GitHub_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }





const CloseIcon = props => /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)("svg", _objectSpread(_objectSpread({
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), {}, {
  "data-test-id": "CloseIcon",
  children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
    d: "M18 6L6 18",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
    d: "M6 6L18 18",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })]
}));


/* unused harmony default export */ var __WEBPACK_DEFAULT_EXPORT__ = ((/* unused pure expression or super */ null && (CloseIcon)));

/***/ }),

/***/ 96766:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "p": () => (/* binding */ DownArrow)
/* harmony export */ });
/* harmony import */ var _opt_jenkins_workspace_TripMoney_Node_16_CDN_Docker_Submit_GitHub_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(95235);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(52322);


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_opt_jenkins_workspace_TripMoney_Node_16_CDN_Docker_Submit_GitHub_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }


const DownArrow = props => /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("svg", _objectSpread(_objectSpread({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), {}, {
  "data-test-id": "DownArrow",
  children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("path", {
    d: "M11.8583 13.3941C11.9364 13.4722 12.063 13.4722 12.1411 13.3941L16.2423 9.29289C16.6329 8.90237 17.266 8.90237 17.6566 9.29289C18.0471 9.68342 18.0471 10.3166 17.6566 10.7071L12.7068 15.6569C12.3163 16.0474 11.6831 16.0474 11.2926 15.6569L6.34285 10.7071C5.95232 10.3166 5.95232 9.68342 6.34285 9.29289C6.73337 8.90237 7.36654 8.90237 7.75706 9.29289L11.8583 13.3941Z",
    fill: "#008CFF"
  })
}));

/***/ }),

/***/ 2384:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "d": () => (/* binding */ EditIcon)
/* harmony export */ });
/* harmony import */ var _opt_jenkins_workspace_TripMoney_Node_16_CDN_Docker_Submit_GitHub_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(95235);
/* harmony import */ var _opt_jenkins_workspace_TripMoney_Node_16_CDN_Docker_Submit_GitHub_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(82269);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(52322);


const _excluded = ["size", "color", "cursor"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_opt_jenkins_workspace_TripMoney_Node_16_CDN_Docker_Submit_GitHub_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }



const EditIcon = _ref => {
  let {
    size = 24,
    color = "#008CFF",
    cursor = "pointer"
  } = _ref,
      props = (0,_opt_jenkins_workspace_TripMoney_Node_16_CDN_Docker_Submit_GitHub_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_ref, _excluded);

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)("svg", _objectSpread(_objectSpread({
    style: {
      cursor: cursor
    },
    width: size,
    height: size,
    viewBox: `0 0 24 24`,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), {}, {
    "data-test-id": "EditIcon",
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M15.378 5.45329C15.9045 4.9268 16.7581 4.9268 17.2846 5.45328L19.0567 7.2254C19.5832 7.75188 19.5832 8.60548 19.0567 9.13196L18.3203 9.86834C18.1097 10.0789 17.7683 10.0789 17.5577 9.86834L14.6416 6.95229C14.431 6.74169 14.431 6.40025 14.6416 6.18966L15.378 5.45329Z",
      fill: color
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M13.1781 7.64303C13.3887 7.43244 13.7302 7.43244 13.9408 7.64303L16.8568 10.5591C17.0674 10.7697 17.0674 11.1111 16.8568 11.3217L10.3652 17.8134C10.2926 17.8859 10.1997 17.9347 10.0988 17.9532L6.59734 18.5945C6.25606 18.657 5.95467 18.365 6.00634 18.0219L6.55028 14.4106C6.56638 14.3038 6.61629 14.2049 6.69271 14.1285L13.1781 7.64303Z",
      fill: color
    })]
  }));
};

/***/ }),

/***/ 44567:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "P": () => (/* binding */ ErrorIcon)
/* harmony export */ });
/* harmony import */ var _opt_jenkins_workspace_TripMoney_Node_16_CDN_Docker_Submit_GitHub_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(95235);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2784);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(52322);


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_opt_jenkins_workspace_TripMoney_Node_16_CDN_Docker_Submit_GitHub_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }




const ErrorIcon = props => /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("svg", _objectSpread(_objectSpread({
  width: "14",
  height: "14",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), {}, {
  "data-test-id": "ErrorIcon",
  children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
    d: "M8 0C3.58 0 0 3.58 0 8C0 12.42 3.58 16 8 16C12.42 16 16 12.42 16 8C16 3.58 12.42 0 8 0ZM8.8 12H7.2V10.4H8.8V12ZM8.8 8.8H7.2V4H8.8V8.8Z",
    fill: "#DC2626"
  })
}));


/* unused harmony default export */ var __WEBPACK_DEFAULT_EXPORT__ = ((/* unused pure expression or super */ null && (ErrorIcon)));

/***/ }),

/***/ 8161:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "a": () => (/* binding */ FileIcon)
/* harmony export */ });
/* harmony import */ var _opt_jenkins_workspace_TripMoney_Node_16_CDN_Docker_Submit_GitHub_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(95235);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2784);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(52322);


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_opt_jenkins_workspace_TripMoney_Node_16_CDN_Docker_Submit_GitHub_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }





const FileIcon = props => /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)("svg", _objectSpread(_objectSpread({
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), {}, {
  "data-test-id": "FileIcon",
  children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
    d: "M14 2H6C4.9 2 4 2.9 4 4V20C4 21.1 4.89 22 5.99 22H18C19.1 22 20 21.1 20 20V8L14 2Z",
    fill: "currentColor"
  }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
    d: "M14 2V8H20",
    fill: "currentColor",
    opacity: "0.5"
  })]
}));


/* unused harmony default export */ var __WEBPACK_DEFAULT_EXPORT__ = ((/* unused pure expression or super */ null && (FileIcon)));

/***/ }),

/***/ 97379:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "r": () => (/* binding */ UploadIcon)
/* harmony export */ });
/* harmony import */ var _opt_jenkins_workspace_TripMoney_Node_16_CDN_Docker_Submit_GitHub_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(95235);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2784);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(52322);


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_opt_jenkins_workspace_TripMoney_Node_16_CDN_Docker_Submit_GitHub_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }





const UploadIcon = props => /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)("svg", _objectSpread(_objectSpread({
  width: "16",
  height: "16",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), {}, {
  "data-test-id": "UploadIcon",
  children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
    d: "M21 15V19C21 20.1 20.1 21 19 21H5C3.9 21 3 20.1 3 19V15",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
    d: "M17 8L12 3L7 8",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
    d: "M12 3V15",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })]
}));


/* unused harmony default export */ var __WEBPACK_DEFAULT_EXPORT__ = ((/* unused pure expression or super */ null && (UploadIcon)));

/***/ }),

/***/ 64204:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "a": () => (/* reexport */ BlueChev),
  "g8": () => (/* reexport */ ChevronUpIcon),
  "DI": () => (/* reexport */ Confetti),
  "rj": () => (/* reexport */ StarEmpty),
  "Um": () => (/* reexport */ StarFull),
  "im": () => (/* reexport */ TripMoneyLogo)
});

// UNUSED EXPORTS: DownArrow, EditIcon, ErrorIcon, MMTIcon

// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(95235);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/icons/BlueChev.tsx


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }



const BlueChev = props => /*#__PURE__*/(0,jsx_runtime.jsx)("svg", _objectSpread(_objectSpread({
  width: 14,
  height: 14,
  viewBox: "0 0 14 14",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), {}, {
  "data-test-id": "BlueChev",
  children: /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.00005 9.5L12.25 4.25L13.5 5.5L7.00005 12.0028L0.5 5.5L1.75 4.25L7.00005 9.5Z",
    fill: "var(--tm-accent-color)"
  })
}));


// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js + 1 modules
var objectWithoutProperties = __webpack_require__(82269);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/icons/ChevronUpIcon.tsx


const _excluded = ["color", "cursor"];

function ChevronUpIcon_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function ChevronUpIcon_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ChevronUpIcon_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ChevronUpIcon_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }


const ChevronUpIcon = _ref => {
  let {
    color = "#008cff",
    cursor = "pointer"
  } = _ref,
      props = (0,objectWithoutProperties/* default */.Z)(_ref, _excluded);

  return /*#__PURE__*/(0,jsx_runtime.jsx)("svg", ChevronUpIcon_objectSpread(ChevronUpIcon_objectSpread({
    style: {
      cursor: cursor
    },
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), {}, {
    "data-test-id": "ChevronUpIcon",
    children: /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      d: "M11.8583 10.6059C11.9364 10.5278 12.063 10.5278 12.1411 10.6059L16.2423 14.7071C16.6329 15.0976 17.266 15.0976 17.6566 14.7071V14.7071C18.0471 14.3166 18.0471 13.6834 17.6566 13.2929L12.7068 8.34315C12.3163 7.95262 11.6831 7.95262 11.2926 8.34315L6.34285 13.2929C5.95232 13.6834 5.95232 14.3166 6.34285 14.7071V14.7071C6.73337 15.0976 7.36654 15.0976 7.75706 14.7071L11.8583 10.6059Z",
      fill: color
    })
  }));
};
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/icons/Confetti.tsx


function Confetti_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function Confetti_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? Confetti_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : Confetti_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }





const Confetti = props => /*#__PURE__*/(0,jsx_runtime.jsxs)("svg", Confetti_objectSpread(Confetti_objectSpread({
  width: 279,
  height: 186,
  viewBox: "0 0 279 186",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), {}, {
  "data-test-id": "Confetti",
  children: [/*#__PURE__*/(0,jsx_runtime.jsx)("ellipse", {
    cx: 167.047,
    cy: 57.6006,
    rx: 4.08312,
    ry: 4.14746,
    fill: "#052F11",
    "data-test-id": "Confetti-ellipse"
  }), /*#__PURE__*/(0,jsx_runtime.jsx)("ellipse", {
    cx: 96.0929,
    cy: 58.9172,
    rx: 2.05284,
    ry: 2.08519,
    fill: "#052F11",
    "data-test-id": "Confetti-ellipse"
  }), /*#__PURE__*/(0,jsx_runtime.jsx)("ellipse", {
    cx: 184.522,
    cy: 91.1717,
    rx: 2.47839,
    ry: 2.51745,
    fill: "#052F11",
    "data-test-id": "Confetti-ellipse"
  }), /*#__PURE__*/(0,jsx_runtime.jsx)("ellipse", {
    cx: 86.4608,
    cy: 118.832,
    rx: 2.47839,
    ry: 2.51745,
    fill: "#052F11",
    "data-test-id": "Confetti-ellipse"
  }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M141.11 65.0256C145.431 60.2392 153.37 63.527 153.041 69.9673C152.834 74.0228 156.179 77.368 160.234 77.1611C166.674 76.8318 169.963 84.7706 165.176 89.0914C162.162 91.8129 162.162 96.5429 165.176 99.2645C169.963 103.586 166.674 111.524 160.234 111.196C156.179 110.988 152.834 114.333 153.041 118.389C153.37 124.829 145.431 128.117 141.11 123.33C138.389 120.316 133.659 120.316 130.937 123.33C126.615 128.117 118.678 124.829 119.006 118.389C119.214 114.333 115.869 110.988 111.813 111.196C105.373 111.524 102.085 103.586 106.871 99.2645C109.885 96.5429 109.885 91.8129 106.871 89.0914C102.085 84.7706 105.373 76.8318 111.813 77.1611C115.869 77.368 119.214 74.0228 119.006 69.9673C118.678 63.527 126.615 60.2392 130.937 65.0256C133.659 68.0397 138.389 68.0397 141.11 65.0256Z",
    fill: "url(#paint0_linear_1129_15509)"
  }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
    d: "M141.11 65.0256V65.0256C145.431 60.2392 153.37 63.527 153.041 69.9673C152.834 74.0228 156.179 77.368 160.234 77.1611C166.674 76.8318 169.963 84.7706 165.176 89.0914C162.162 91.8129 162.162 96.5429 165.176 99.2645C169.963 103.586 166.674 111.524 160.234 111.196C156.179 110.988 152.834 114.333 153.041 118.389C153.37 124.829 145.431 128.117 141.11 123.33C138.389 120.316 133.659 120.316 130.937 123.33C126.615 128.117 118.678 124.829 119.006 118.389C119.214 114.333 115.869 110.988 111.813 111.196C105.373 111.524 102.085 103.586 106.871 99.2645C109.885 96.5429 109.885 91.8129 106.871 89.0914C102.085 84.7706 105.373 76.8318 111.813 77.1611C115.869 77.368 119.214 74.0228 119.006 69.9673C118.678 63.527 126.615 60.2392 130.937 65.0256C133.659 68.0397 138.389 68.0397 141.11 65.0256",
    stroke: "#052F11",
    strokeWidth: 3.84498
  }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
    d: "M121.699 95.1193L130.32 103.74L150.435 83.625",
    stroke: "#052F11",
    strokeWidth: 3.84498,
    strokeLinecap: "round"
  }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
    d: "M219.806 11.7625C218.876 11.3514 217.919 11.0267 216.958 10.732C216.001 10.4355 215.032 10.1728 214.055 9.99866C214.179 10.0222 212.729 9.78728 212.793 9.99213C213.88 13.3471 212.352 17.234 210.728 19.8914C209.808 21.3937 208.602 22.5861 207.244 23.4084C206.661 23.7611 206.025 23.9713 205.392 24.1349C205.097 24.212 204.793 24.2482 204.489 24.2843C204.381 24.2979 204.272 24.295 204.161 24.2989C204.015 24.2635 203.873 24.2262 203.727 24.1909C203.129 24.0503 202.418 23.8357 201.797 23.9205C201.257 23.9935 202.173 24.4619 202.13 24.4381C202.896 24.8565 203.711 25.1323 204.516 25.4188C208.78 26.9319 213.235 28.1374 217.038 24.633C219.699 22.1824 222.277 16.6621 220.922 12.4817C220.801 12.0964 220.024 11.8579 219.804 11.7577L219.806 11.7625Z",
    fill: "url(#paint1_linear_1129_15509)"
  }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
    d: "M250.565 59.0618C250.927 59.222 251.3 59.3486 251.675 59.4635C252.048 59.579 252.425 59.6814 252.806 59.7493C252.758 59.7401 253.323 59.8317 253.298 59.7518C252.874 58.4442 253.47 56.9293 254.103 55.8935C254.462 55.308 254.932 54.8432 255.461 54.5227C255.688 54.3852 255.936 54.3033 256.183 54.2396C256.298 54.2095 256.416 54.1954 256.534 54.1813C256.577 54.176 256.619 54.1772 256.662 54.1757C256.719 54.1894 256.775 54.204 256.832 54.2178C257.065 54.2726 257.342 54.3562 257.584 54.3231C257.794 54.2947 257.437 54.1121 257.454 54.1214C257.156 53.9583 256.838 53.8508 256.524 53.7392C254.862 53.1494 253.126 52.6796 251.644 54.0455C250.606 55.0006 249.602 57.1522 250.13 58.7815C250.177 58.9317 250.48 59.0246 250.566 59.0637L250.565 59.0618Z",
    fill: "url(#paint2_linear_1129_15509)"
  }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
    d: "M214.489 103.654C215.178 106.788 215.864 109.923 216.553 113.057C216.475 112.707 220.813 110.797 220.718 110.365C220.029 107.231 219.344 104.096 218.655 100.962C218.733 101.312 214.394 103.222 214.489 103.654Z",
    fill: "url(#paint3_linear_1129_15509)"
  }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
    d: "M173.185 65.741C175.847 66.2212 178.509 66.7015 181.171 67.1817C180.875 67.1294 181.221 61.194 180.855 61.1314C178.193 60.6512 175.531 60.171 172.869 59.6907C173.165 59.743 172.819 65.6784 173.185 65.741Z",
    fill: "url(#paint4_linear_1129_15509)"
  }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
    d: "M59.1576 118.613C59.383 118.672 60.8262 115.349 60.9577 115.094C61.0742 114.862 62.5512 111.49 62.6988 111.53C59.7428 110.8 57.1597 109.105 54.9999 106.478C55.3043 106.847 51.087 113.108 51.4602 113.566C53.6201 116.194 56.2032 117.888 59.1592 118.618L59.1576 118.613Z",
    fill: "url(#paint5_linear_1129_15509)"
  }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
    d: "M250.592 107.131C253.176 110.107 256.208 112.201 259.598 113.354C259.8 113.424 260.835 112.793 260.933 112.745C262.003 112.238 263.068 111.717 264.133 111.195C265.199 110.674 265.03 111.617 266.091 111.081C266.122 111.066 267.266 110.348 267.402 110.394C264.012 109.241 260.979 107.148 258.395 104.171C258.093 103.824 255.47 104.675 255.092 104.86C254.756 105.024 250.809 107.379 250.592 107.131Z",
    fill: "url(#paint6_linear_1129_15509)"
  }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
    d: "M131.166 48.6691C130.889 48.546 129.33 48.1671 129.19 47.8361C130.364 50.6199 129.065 53.399 127.766 55.7004C126.695 57.5972 125.176 59.1399 123.352 59.352L126.264 61.0485C128.603 61.4168 130.365 59.6147 131.699 57.4089C133.053 55.182 134.273 52.267 133.123 49.5447C132.963 49.1619 131.467 48.7973 131.164 48.6642L131.166 48.6691Z",
    fill: "url(#paint7_linear_1129_15509)"
  }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
    d: "M13.0545 22.8896C12.4546 22.5164 11.832 22.1966 11.2065 21.8981C10.581 21.5995 9.94703 21.3188 9.29882 21.102C9.37842 21.1304 8.41748 20.8213 8.44875 20.967C8.95765 23.3409 7.6726 25.7966 6.39893 27.4171C5.67964 28.3304 4.78692 29.0092 3.82029 29.425C3.40521 29.6027 2.9617 29.6773 2.52387 29.7235C2.31917 29.7448 2.11163 29.7377 1.90694 29.7306C1.83302 29.7271 1.7591 29.7164 1.68518 29.7093C1.59136 29.6702 1.4947 29.6311 1.40088 29.592C1.00854 29.4356 0.542281 29.2189 0.121513 29.2082C-0.245238 29.2011 0.337583 29.6098 0.311995 29.592C0.800997 29.9509 1.33264 30.2246 1.85292 30.4982C4.62203 31.9588 7.54183 33.2346 10.3365 31.273C12.2925 29.9012 14.3935 26.4505 13.7595 23.4937C13.7027 23.2236 13.1966 22.9784 13.0545 22.8896Z",
    fill: "url(#paint8_linear_1129_15509)"
  }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
    d: "M78.8516 63.6931C80.3129 63.3377 82.2319 60.5231 82.1751 59.3681C82.0955 59.5671 79.7784 59.034 79.8665 58.8848C79.6704 59.9438 77.3732 61.6994 76 61.4044C76.0569 61.4435 77.1429 62.6696 77.285 62.7229C77.3703 62.8579 78.6895 63.7926 78.8516 63.6966V63.6931Z",
    fill: "url(#paint9_linear_1129_15509)"
  }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
    d: "M95.4083 9.33366C95.5334 9.09911 93.6627 6.20276 93.5234 5.96111C93.3983 5.74077 91.502 2.79113 91.5845 2.63477C89.9355 5.71945 87.7265 8.01875 85 9.48291C85.381 9.27679 88.3491 16.4377 88.821 16.1818C91.5475 14.7176 93.7565 12.4183 95.4055 9.33366H95.4083Z",
    fill: "url(#paint10_linear_1129_15509)"
  }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
    d: "M14.4083 115.584C14.5334 115.349 12.6627 112.453 12.5234 112.211C12.3983 111.991 10.502 109.041 10.5845 108.885C8.9355 111.969 6.72647 114.269 4 115.733C4.38097 115.527 7.34909 122.688 7.82103 122.432C10.5475 120.968 12.7565 118.668 14.4055 115.584H14.4083Z",
    fill: "url(#paint11_linear_1129_15509)"
  }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
    d: "M32.333 69.7695C35.1903 68.4084 37.6751 66.2655 39.7078 63.4118C39.8301 63.2412 39.8386 61.9867 39.8471 61.873C39.9467 60.6327 40.0348 59.396 40.1258 58.1557C40.2139 56.9155 40.2992 55.6752 40.3788 54.4349C40.3788 54.3994 40.3788 53.0063 40.4584 52.8926C38.4256 55.7498 35.9408 57.8892 33.0836 59.2503C32.7481 59.4102 32.6969 64.0657 32.6656 64.5064C32.6372 64.8973 32.5747 69.6558 32.333 69.7695Z",
    fill: "url(#paint12_linear_1129_15509)"
  }), /*#__PURE__*/(0,jsx_runtime.jsxs)("defs", {
    "data-test-id": "Confetti-defs",
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("linearGradient", {
      id: "paint0_linear_1129_15509",
      x1: 130.576,
      y1: 35.5895,
      x2: 76.2584,
      y2: 95.5823,
      gradientUnits: "userSpaceOnUse",
      "data-test-id": "Confetti-linearGradient",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("stop", {
        stopColor: "#4AFFCD",
        "data-test-id": "Confetti-stop"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("stop", {
        offset: 1,
        stopColor: "#7DBFCC",
        "data-test-id": "Confetti-stop"
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("linearGradient", {
      id: "paint1_linear_1129_15509",
      x1: 209.278,
      y1: 30.6128,
      x2: 216.802,
      y2: 6.36303,
      gradientUnits: "userSpaceOnUse",
      "data-test-id": "Confetti-linearGradient",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("stop", {
        stopColor: "#B4DF86",
        "data-test-id": "Confetti-stop"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("stop", {
        offset: 1,
        stopColor: "#84C743",
        "data-test-id": "Confetti-stop"
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("linearGradient", {
      id: "paint2_linear_1129_15509",
      x1: 254.668,
      y1: 51.7148,
      x2: 251.736,
      y2: 61.1663,
      gradientUnits: "userSpaceOnUse",
      "data-test-id": "Confetti-linearGradient",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("stop", {
        stopColor: "#B4DF86",
        "data-test-id": "Confetti-stop"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("stop", {
        offset: 1,
        stopColor: "#84C743",
        "data-test-id": "Confetti-stop"
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("linearGradient", {
      id: "paint3_linear_1129_15509",
      x1: 215.051,
      y1: 108.262,
      x2: 220.415,
      y2: 106.581,
      gradientUnits: "userSpaceOnUse",
      "data-test-id": "Confetti-linearGradient",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("stop", {
        stopColor: "#F71873",
        "data-test-id": "Confetti-stop"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("stop", {
        offset: 1,
        stopColor: "#C6211B",
        "data-test-id": "Confetti-stop"
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("linearGradient", {
      id: "paint4_linear_1129_15509",
      x1: 172.315,
      y1: 62.2785,
      x2: 183.483,
      y2: 64.0504,
      gradientUnits: "userSpaceOnUse",
      "data-test-id": "Confetti-linearGradient",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("stop", {
        stopColor: "#F71873",
        "data-test-id": "Confetti-stop"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("stop", {
        offset: 1,
        stopColor: "#F8A629",
        "data-test-id": "Confetti-stop"
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("linearGradient", {
      id: "paint5_linear_1129_15509",
      x1: 60.9026,
      y1: 115.893,
      x2: 52.0739,
      y2: 111.483,
      gradientUnits: "userSpaceOnUse",
      "data-test-id": "Confetti-linearGradient",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("stop", {
        stopColor: "#BE1E68",
        "data-test-id": "Confetti-stop"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("stop", {
        offset: 1,
        stopColor: "#B5188D",
        "data-test-id": "Confetti-stop"
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("linearGradient", {
      id: "paint6_linear_1129_15509",
      x1: 260.738,
      y1: 114.32,
      x2: 254.675,
      y2: 101.936,
      gradientUnits: "userSpaceOnUse",
      "data-test-id": "Confetti-linearGradient",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("stop", {
        stopColor: "#B5188D",
        "data-test-id": "Confetti-stop"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("stop", {
        offset: 1,
        stopColor: "#4E69AE",
        "data-test-id": "Confetti-stop"
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("linearGradient", {
      id: "paint7_linear_1129_15509",
      x1: 126.048,
      y1: 61.945,
      x2: 136.85,
      y2: 46.2851,
      gradientUnits: "userSpaceOnUse",
      "data-test-id": "Confetti-linearGradient",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("stop", {
        stopColor: "#F71873",
        "data-test-id": "Confetti-stop"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("stop", {
        offset: 1,
        stopColor: "#C6211B",
        "data-test-id": "Confetti-stop"
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("linearGradient", {
      id: "paint8_linear_1129_15509",
      x1: 4.83046,
      y1: 34.4623,
      x2: 12.1426,
      y2: 19.2222,
      gradientUnits: "userSpaceOnUse",
      "data-test-id": "Confetti-linearGradient",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("stop", {
        stopColor: "#F71873",
        "data-test-id": "Confetti-stop"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("stop", {
        offset: 1,
        stopColor: "#C6211B",
        "data-test-id": "Confetti-stop"
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("linearGradient", {
      id: "paint9_linear_1129_15509",
      x1: 80.4465,
      y1: 57.648,
      x2: 76.8863,
      y2: 62.6449,
      gradientUnits: "userSpaceOnUse",
      "data-test-id": "Confetti-linearGradient",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("stop", {
        stopColor: "#6DD0E7",
        "data-test-id": "Confetti-stop"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("stop", {
        offset: 1,
        stopColor: "#01A7DB",
        "data-test-id": "Confetti-stop"
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("linearGradient", {
      id: "paint10_linear_1129_15509",
      x1: 94.0188,
      y1: 6.24712,
      x2: 85.4772,
      y2: 11.1176,
      gradientUnits: "userSpaceOnUse",
      "data-test-id": "Confetti-linearGradient",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("stop", {
        stopColor: "#FBE422",
        "data-test-id": "Confetti-stop"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("stop", {
        offset: 1,
        stopColor: "#C8D92B",
        "data-test-id": "Confetti-stop"
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("linearGradient", {
      id: "paint11_linear_1129_15509",
      x1: 13.0188,
      y1: 112.497,
      x2: 4.47722,
      y2: 117.368,
      gradientUnits: "userSpaceOnUse",
      "data-test-id": "Confetti-linearGradient",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("stop", {
        stopColor: "#FBE422",
        "data-test-id": "Confetti-stop"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("stop", {
        offset: 1,
        stopColor: "#C8D92B",
        "data-test-id": "Confetti-stop"
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("linearGradient", {
      id: "paint12_linear_1129_15509",
      x1: 40.2976,
      y1: 61.8037,
      x2: 30.9061,
      y2: 61.1345,
      gradientUnits: "userSpaceOnUse",
      "data-test-id": "Confetti-linearGradient",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("stop", {
        stopColor: "#F8B54A",
        "data-test-id": "Confetti-stop"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("stop", {
        offset: 1,
        stopColor: "#F8A629",
        "data-test-id": "Confetti-stop"
      })]
    })]
  })]
}));


// EXTERNAL MODULE: ../../libs/ui/src/lib/static/icons/DownArrow.tsx
var DownArrow = __webpack_require__(96766);
// EXTERNAL MODULE: ../../libs/ui/src/lib/static/icons/EditIcon.tsx
var EditIcon = __webpack_require__(2384);
// EXTERNAL MODULE: ../../libs/ui/src/lib/static/icons/ErrorIcon.tsx
var ErrorIcon = __webpack_require__(44567);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/icons/MMTIcon.tsx


function MMTIcon_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function MMTIcon_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? MMTIcon_ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : MMTIcon_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }



const MMTIcon = ({
  props
}) => /*#__PURE__*/_jsxs("svg", MMTIcon_objectSpread(MMTIcon_objectSpread({
  width: 86,
  height: 28,
  viewBox: "0 0 86 28",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), {}, {
  "data-test-id": "MMTIcon",
  children: [/*#__PURE__*/_jsx("rect", {
    x: 37.2598,
    y: 4.68359,
    width: 23.8612,
    height: 22.4215,
    rx: 6,
    fill: "white",
    "data-test-id": "MMTIcon-rect"
  }), /*#__PURE__*/_jsx("mask", {
    id: "mask0_1734_41229",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 35,
    y: 0,
    width: 28,
    height: 28,
    "data-test-id": "MMTIcon-mask",
    children: /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M62.6091 27.8695V0.365234H35.2988V27.8695H62.6091Z",
      fill: "white"
    })
  }), /*#__PURE__*/_jsx("g", {
    mask: "url(#mask0_1734_41229)",
    children: /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M60.3565 9.77361C59.0587 12.0098 56.74 16.8177 56.74 16.8177C56.74 16.8177 55.5721 19.4131 55.0783 22.0653C54.8587 23.2447 55.2827 24.6147 55.2827 24.6147C55.5999 25.9675 54.0972 25.5958 54.0972 25.5958C52.9995 25.2332 53.03 23.7589 53.03 23.7589C53.03 21.5828 53.9928 19.4794 54.557 18.0716C52.5746 18.8576 51.6475 16.9195 52.2116 14.9624L49.9456 18.0365C49.2164 18.8983 48.498 18.7296 48.498 18.7296C48.4615 18.7296 47.5896 18.6228 47.6337 17.4529C47.6551 16.8864 47.8134 14.5232 47.9949 13.6455C48.0133 13.5537 47.9589 13.4623 47.8859 13.5722C46.9409 15.2542 45.3924 17.0873 45.0845 17.5955C44.6851 18.2544 44.2844 18.5275 44.2844 18.5275C43.9624 18.7885 43.403 18.5912 43.403 18.5912C42.8298 18.3774 42.947 17.7255 42.947 17.7255L43.4898 13.7871C43.4898 13.7331 43.4719 13.7143 43.4172 13.7143C43.2538 13.7143 41.7173 15.8555 40.8695 17.3493L40.3144 18.252C40.3144 18.252 39.8351 19.0085 39.0948 18.5534C38.5159 18.1973 38.6979 17.5318 38.6979 17.5318L40.2856 10.8112C40.2856 10.7929 40.2856 10.6832 40.1943 10.6832C39.7034 10.6832 39.5637 11.9704 38.8925 11.9952C38.5548 12.0077 38.3808 11.8623 38.3808 11.8623C37.923 11.5974 38.1403 10.9105 38.1403 10.9105C38.1403 10.9105 38.8655 8.97975 39.8266 8.4945C39.8266 8.4945 40.3811 8.14464 40.843 8.20718C41.3051 8.26972 42.0443 8.38121 41.6563 10.5005L41.1715 13.2572C41.1715 13.2572 41.1231 13.4983 41.1982 13.5368C41.1982 13.5368 41.3179 13.6566 41.5593 13.333L44.6338 9.10418C45.2961 8.12532 46.0768 8.61909 46.0768 8.61909C46.5968 8.84109 46.4184 9.48236 46.4184 9.48236C46.4184 9.48236 44.903 14.1629 44.903 14.6016C44.903 14.748 45.0306 14.7842 45.1029 14.6751C45.7389 13.7056 47.0844 11.6023 48.2122 10.1944C48.7206 9.57273 49.0121 9.29818 49.5753 9.35319C50.1205 9.40804 50.3752 9.75544 50.3752 10.3041C50.3752 10.3956 50.3568 10.5053 50.3393 10.6151C50.3393 10.6151 49.3391 14.0715 49.2659 15.9184C49.2659 15.9184 49.2504 16.1839 49.3204 16.2376C49.4552 16.3411 49.6215 16.1081 49.6215 16.1081C50.1811 15.488 51.9707 12.6424 52.3752 11.8951L53.6699 9.24514C53.6699 9.24514 54.2194 8.03953 54.9533 8.22699C54.9533 8.22699 56.1209 8.34552 55.5568 9.62381C55.4643 9.83304 54.5754 11.2864 53.8114 14.2863C53.6843 14.7429 53.5204 16.0783 54.3382 16.0783C54.702 16.0783 55.175 15.7851 55.6658 14.8889L58.8834 9.07389C59.156 8.78084 59.3718 8.61909 59.7532 8.61909C60.9445 8.61909 60.3565 9.77361 60.3565 9.77361ZM62.6087 6.59235C62.6087 3.15774 59.8562 0.365234 56.4625 0.365234H41.4468C38.052 0.365234 35.2998 3.15774 35.2998 6.59235L35.3031 21.6389C35.3031 25.0725 38.0548 27.8696 41.4493 27.8696H56.4648C59.8593 27.8696 62.61 25.0733 62.61 21.6389L62.6087 6.59235Z",
      fill: "#EB2226"
    })
  }), /*#__PURE__*/_jsx("mask", {
    id: "mask1_1734_41229",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 10,
    width: 11,
    height: 8,
    "data-test-id": "MMTIcon-mask",
    children: /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M0 17.5647H10.3158V10.5566H0L0 17.5647Z",
      fill: "white"
    })
  }), /*#__PURE__*/_jsx("g", {
    mask: "url(#mask1_1734_41229)",
    children: /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M6.00933 17.5647H4.30673V13.7095C4.30673 13.1602 4.21981 12.7499 4.0468 12.4795C3.87363 12.209 3.58099 12.0735 3.16775 12.0735C2.86697 12.0735 2.59159 12.1481 2.34159 12.2978C2.09078 12.4479 1.87822 12.6609 1.70277 12.9371V17.5647H0V10.5634H0.969709L1.60983 11.505C1.74736 11.3792 1.95602 11.2205 2.12496 11.1107C2.29407 11.0008 2.47245 10.9042 2.66043 10.822C2.84793 10.74 3.04552 10.6758 3.25206 10.6279C3.4586 10.5802 3.67051 10.5566 3.88763 10.5566C4.13746 10.5566 4.358 10.5832 4.54728 10.6372C4.73755 10.6904 4.90535 10.7685 5.05134 10.8718C5.19734 10.9744 5.3251 11.0981 5.4335 11.2429C5.54206 11.3886 5.6376 11.5527 5.72109 11.7359C5.85471 11.6016 6.00592 11.4646 6.17518 11.3237C6.34413 11.1829 6.53097 11.0558 6.73556 10.9419C6.94014 10.8281 7.16312 10.7354 7.40514 10.6639C7.64749 10.5923 7.90985 10.5566 8.19419 10.5566C8.57765 10.5566 8.90381 10.6354 9.17367 10.7924C9.44287 10.9499 9.66178 11.1676 9.83104 11.4461C9.99999 11.7246 10.1224 12.0561 10.1999 12.4402C10.277 12.8246 10.3159 13.2436 10.3159 13.6967V17.5647H8.61313V13.7095C8.61313 13.1602 8.52768 12.7499 8.35646 12.4795C8.18556 12.209 7.89927 12.0735 7.49938 12.0735C7.19877 12.0735 6.92305 12.1439 6.67241 12.2843C6.42225 12.425 6.20139 12.6419 6.00933 12.9371V17.5647Z",
      fill: "white"
    })
  }), /*#__PURE__*/_jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.9324 14.3823H14.4049C13.9962 14.3823 13.6976 14.4792 13.5094 14.6372C13.3219 14.7945 13.228 15.0149 13.228 15.2966C13.228 15.5656 13.3074 15.7729 13.4661 15.9188C13.6246 16.0638 13.8667 16.1375 14.1917 16.1375C14.3883 16.1375 14.5747 16.111 14.7524 16.0586C14.93 16.0055 15.0935 15.9351 15.2438 15.8456C15.3937 15.756 15.5271 15.6503 15.6443 15.5263C15.7607 15.4029 15.8569 15.2724 15.9324 15.1354V14.3823ZM15.9317 16.7939C15.735 17.0092 15.4264 17.2102 15.0777 17.3553C14.7291 17.4994 14.3128 17.5722 13.8291 17.5722C13.491 17.5722 13.1863 17.5179 12.9145 17.4085C12.6434 17.3001 12.4114 17.1472 12.2173 16.9501C12.0233 16.753 11.8739 16.5207 11.7692 16.2517C11.6652 15.9824 11.6133 15.6887 11.6133 15.3691C11.6133 14.0646 12.6159 13.2355 14.2224 13.2355H15.919V12.8485C15.919 12.6095 15.7994 12.4214 15.5593 12.2852C15.3198 12.1489 14.9514 12.08 14.4547 12.08C13.9915 12.08 13.5626 12.1291 13.1686 12.2269C12.7746 12.324 12.556 12.4063 12.2179 12.5464L12.0075 11.0851C12.1323 11.0298 12.285 10.9715 12.4645 10.9099C12.6434 10.8482 12.8444 10.7914 13.0652 10.7382C13.2864 10.6861 13.5263 10.6421 13.7851 10.608C14.0434 10.5733 14.3152 10.5566 14.5987 10.5566C15.5836 10.5566 16.3232 10.7989 16.8179 11.2847C17.3119 11.7695 17.5593 12.4592 17.5593 13.3532V17.5647H16.3461L15.9317 16.7939Z",
    fill: "white"
  }), /*#__PURE__*/_jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.6119 10.4593L22.8357 13.9617L25.9934 17.5649H23.8528L20.9329 14.01V17.5649H19.2305V7.95508H20.9329V14.01L23.5336 10.4593H25.6119Z",
    fill: "white"
  }), /*#__PURE__*/_jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.3989 12.0668C29.1738 12.0668 28.9692 12.0946 28.7851 12.1509C28.6017 12.2071 28.441 12.2873 28.3035 12.3899C28.166 12.4932 28.0528 12.6177 27.9651 12.7635C27.8777 12.9105 27.8173 13.0715 27.7838 13.2475H30.8074C30.8074 13.0898 30.779 12.939 30.7224 12.7948C30.6664 12.6502 30.5798 12.5248 30.4626 12.4184C30.3461 12.311 30.1988 12.2259 30.0219 12.1622C29.8442 12.0987 29.637 12.0668 29.3989 12.0668ZM29.7177 16.0621C30.0182 16.0621 30.2906 16.0375 30.5346 15.9899C30.7787 15.9423 31.0011 15.8787 31.2011 15.8011C31.4018 15.723 31.5834 15.6323 31.7458 15.53C31.9084 15.4269 31.8518 15.4758 31.9852 15.3699L32.3137 16.8826C32.0129 17.0753 31.5881 17.2459 31.1602 17.3759C30.7327 17.5064 30.246 17.5722 29.6992 17.5722C29.1025 17.5722 28.5742 17.4879 28.1157 17.3204C27.6564 17.1524 27.269 16.917 26.9538 16.6123C26.6393 16.3077 26.3997 15.9423 26.2373 15.5141C26.0749 15.086 25.9932 14.6116 25.9932 14.0911C25.9932 13.6101 26.0675 13.1555 26.2155 12.7274C26.3636 12.2991 26.5807 11.9245 26.8664 11.6023C27.1523 11.2799 27.5058 11.0254 27.9274 10.8377C28.3492 10.6506 28.8354 10.5566 29.386 10.5566C29.9413 10.5566 30.4195 10.6457 30.8228 10.8237C31.2248 11.0018 31.557 11.2388 31.8174 11.5347C32.0787 11.8313 32.2714 12.1714 32.3972 12.5556C32.5223 12.9397 32.5682 13.338 32.5682 13.7504C32.5682 13.8616 32.5617 13.9894 32.5492 14.1329C32.5367 14.2764 32.5204 14.3982 32.4992 14.497H27.7526C27.7773 14.7391 27.84 14.9568 27.9401 15.1487C28.04 15.3413 28.1748 15.5048 28.3437 15.6397C28.513 15.7746 28.713 15.8787 28.9444 15.9519C29.1761 16.0256 29.434 16.0621 29.7177 16.0621Z",
    fill: "white"
  }), /*#__PURE__*/_jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.2822 11.5566L66.5825 8.80273H67.0869V10.5633H69.0522V12.0875H67.0869V14.9568C67.0869 15.1562 67.1106 15.3227 67.1588 15.456C67.2062 15.5883 67.2727 15.694 67.3564 15.7743C67.4392 15.8537 67.5353 15.9097 67.6435 15.9436C67.7522 15.9766 67.8674 15.993 67.9881 15.993C68.2133 15.993 68.4127 15.9714 68.5854 15.9277C68.759 15.8844 68.9128 15.8294 69.0461 15.7641V17.29C68.8621 17.3821 68.6692 17.4519 68.467 17.4998C68.2646 17.5485 68.0173 17.5722 67.725 17.5722C67.3121 17.5722 66.9571 17.5232 66.6613 17.4245C66.365 17.3258 66.1227 17.1837 65.9355 16.9959C65.7466 16.8076 65.608 16.5793 65.5187 16.3113C65.4292 16.0433 65.3836 15.7394 65.3836 15.3995V12.0875H64.2822V11.5566Z",
    fill: "white"
  }), /*#__PURE__*/_jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M71.955 12.006C72.1847 11.5864 72.5958 11.1824 72.936 10.9319C73.2757 10.6817 73.6842 10.5566 74.1593 10.5566C74.3219 10.5566 74.4552 10.5648 74.5572 10.581C74.6594 10.5972 74.7374 10.613 74.7918 10.6269C74.7918 10.6269 74.7374 11.0229 74.4788 12.2323C74.374 12.209 74.2491 12.1972 74.1028 12.1972C73.7815 12.1972 73.4952 12.2527 73.2423 12.3646C72.9899 12.4764 72.776 12.6375 72.6012 12.8469C72.4262 13.0568 72.2913 13.3144 72.1974 13.618C72.1028 13.9218 72.0563 14.2658 72.0563 14.6495V17.5647H70.3535V10.5632H71.4445L71.955 12.006Z",
    fill: "white"
  }), /*#__PURE__*/_jsx("mask", {
    id: "mask2_1734_41229",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 79,
    y: 10,
    width: 7,
    height: 11,
    "data-test-id": "MMTIcon-mask",
    children: /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M85.9243 20.3934V10.5566L79.2148 10.5566V20.3934H85.9243Z",
      fill: "white"
    })
  }), /*#__PURE__*/_jsx("g", {
    mask: "url(#mask2_1734_41229)",
    children: /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M82.5325 12.0876C82.316 12.0876 82.1192 12.1199 81.9443 12.1847C81.7694 12.2491 81.6147 12.333 81.481 12.4368C81.3473 12.5395 81.2328 12.6575 81.137 12.789C81.0409 12.92 80.963 13.0549 80.9055 13.1927V15.1809C80.9716 15.3009 81.0589 15.4147 81.1645 15.5222C81.2711 15.6293 81.3907 15.7236 81.5248 15.8053C81.6584 15.8868 81.807 15.952 81.9722 16.0019C82.1371 16.0509 82.3132 16.0754 82.5014 16.0754C82.7888 16.0754 83.0386 16.0283 83.2491 15.9335C83.4598 15.8397 83.6348 15.7074 83.7751 15.5381C83.9149 15.3679 84.0188 15.1642 84.0848 14.9257C84.1516 14.6876 84.1848 14.4244 84.1848 14.1364C84.1848 13.836 84.1454 13.5599 84.0656 13.3085C83.9867 13.057 83.8746 12.8414 83.7281 12.661C83.5813 12.4807 83.4078 12.3396 83.2053 12.2391C83.0023 12.1379 82.7787 12.0876 82.5325 12.0876ZM84.2999 10.8505C84.6698 11.0471 84.9753 11.3099 85.2169 11.6388C85.4592 11.9677 85.6376 12.3469 85.7525 12.7778C85.8669 13.2072 85.9244 13.6545 85.9244 14.1171C85.9244 14.5896 85.8638 15.0336 85.7429 15.4511C85.6218 15.8683 85.4395 16.2342 85.1954 16.5498C84.9512 16.8646 84.6475 17.1141 84.2841 17.2975C83.9216 17.481 83.496 17.5722 83.0074 17.5722C82.5318 17.5722 82.1303 17.5026 81.8025 17.3623C81.4751 17.2235 81.188 17.0185 80.9422 16.7482L80.9171 16.7628V20.3934H79.2148V10.5634H80.2331L80.8834 11.4162C81.1302 11.1626 81.4808 10.9162 81.8214 10.7724C82.1619 10.6285 82.5458 10.5566 82.9763 10.5566C83.4895 10.5566 83.9314 10.6554 84.2999 10.8505Z",
      fill: "white"
    })
  }), /*#__PURE__*/_jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M76.5459 7.68164C76.0555 7.68164 75.6592 8.08111 75.6592 8.57406C75.6592 9.06717 76.0555 9.46697 76.5459 9.46697C77.0359 9.46697 77.4331 9.06717 77.4331 8.57406C77.4331 8.08111 77.0359 7.68164 76.5459 7.68164ZM75.695 17.5648H77.3974V10.5635H75.695V17.5648Z",
    fill: "white"
  })]
}));
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/icons/StarEmpty.tsx


const StarEmpty_excluded = ["width", "height"];

function StarEmpty_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function StarEmpty_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? StarEmpty_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : StarEmpty_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }




const StarEmpty = _ref => {
  let {
    width = 26,
    height = 25
  } = _ref,
      props = (0,objectWithoutProperties/* default */.Z)(_ref, StarEmpty_excluded);

  return /*#__PURE__*/(0,jsx_runtime.jsx)("svg", StarEmpty_objectSpread(StarEmpty_objectSpread({
    width: width,
    height: height,
    viewBox: "0 0 26 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), {}, {
    "data-test-id": "StarEmpty",
    children: /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M13.0675 19.9704L6.05072 23.7389L7.3908 15.7571L1.71415 10.1044L9.55909 8.93983L13.0675 1.67773L16.5758 8.93983L24.4208 10.1044L18.7441 15.7571L20.0842 23.7389L13.0675 19.9704Z",
      fill: "#E2B634",
      fillOpacity: 0.1,
      stroke: "#E2B634",
      strokeOpacity: 0.4
    })
  }));
};


;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/icons/StarFull.tsx


const StarFull_excluded = ["width", "height"];

function StarFull_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function StarFull_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? StarFull_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : StarFull_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }




const StarFull = _ref => {
  let {
    width = 24,
    height = 23
  } = _ref,
      props = (0,objectWithoutProperties/* default */.Z)(_ref, StarFull_excluded);

  return /*#__PURE__*/(0,jsx_runtime.jsx)("svg", StarFull_objectSpread(StarFull_objectSpread({
    width: width,
    height: height,
    viewBox: "0 0 24 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), {}, {
    "data-test-id": "StarFull",
    children: /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M11.9415 18.9704L4.92475 22.7389L6.26482 14.7571L0.588172 9.10436L8.43311 7.93983L11.9415 0.677734L15.4498 7.93983L23.2948 9.10436L17.6181 14.7571L18.9582 22.7389L11.9415 18.9704Z",
      fill: "#E2B634"
    })
  }));
};


;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/icons/TripMoneyLogo.tsx




const TripMoneyLogo = ({
  darkHeader,
  lightHeader
}) => /*#__PURE__*/(0,jsx_runtime.jsxs)("svg", {
  width: 140,
  height: 39,
  viewBox: "0 0 140 39",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  "data-test-id": "TripMoneyLogo",
  children: [/*#__PURE__*/(0,jsx_runtime.jsx)("path", {
    d: "M6.50765 10.3113V17.873C6.50765 18.5604 6.73679 18.7896 6.87427 18.8812C7.14924 19.0187 7.47004 19.1104 7.8825 19.1104C8.2033 19.1104 9.1657 18.8354 9.71564 18.6062L10.3114 18.4229V21.3101L10.0823 21.4476C9.25735 21.8601 8.38661 22.0892 7.47004 22.0892C3.89542 22.0892 3.11634 19.9353 3.11634 18.1021V10.3113H0L6.50765 3.75781V7.33243H10.3572V10.3113H6.50765Z",
    fill: lightHeader ? "white" : darkHeader ? "#124680" : "white"
  }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
    d: "M21.0806 7.05664V10.2646H20.3932C19.4308 10.2646 18.5142 10.4479 17.6435 10.8146C16.8644 11.1812 16.2686 11.6395 15.8103 12.2353V21.7218H12.4648V7.33161H14.8938L15.4895 9.07309C16.7727 7.74407 18.4225 7.10247 20.3473 7.10247H21.0806V7.05664Z",
    fill: lightHeader ? "white" : darkHeader ? "#124680" : "white"
  }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
    d: "M26.3506 3.57547C26.3506 4.53787 25.5716 5.31695 24.6092 5.31695C23.6468 5.31695 22.8677 4.53787 22.8677 3.57547C22.8677 2.61307 23.6468 1.83398 24.6092 1.83398C25.5257 1.83398 26.3506 2.61307 26.3506 3.57547Z",
    fill: lightHeader ? "white" : darkHeader ? "#124680" : "white"
  }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
    d: "M26.2132 7.33203H22.8677V21.8138H26.2132V7.33203Z",
    fill: lightHeader ? "white" : darkHeader ? "#124680" : "white"
  }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
    d: "M41.886 9.074C40.5112 7.69915 38.9072 7.01172 37.074 7.01172C35.2409 7.01172 33.4994 8.1116 32.7203 8.70737L32.0329 7.33252H29.604V27.9095H32.9495V20.6228C34.141 21.5852 35.5159 22.0893 37.0282 22.0893C38.8155 22.0893 40.3737 21.4477 41.7027 20.1645L41.8402 20.027C43.2151 18.6522 43.9025 16.819 43.9025 14.5734C43.9483 12.282 43.2609 10.4489 41.886 9.074ZM36.7074 18.8813C35.2867 18.8813 34.0494 18.3314 32.9495 17.1856V11.9154C34.0494 10.7697 35.2409 10.2197 36.7074 10.2197C37.899 10.2197 38.8155 10.5863 39.5488 11.3196C40.282 12.0529 40.6028 13.1527 40.6028 14.5276C40.6028 15.9024 40.2362 17.0023 39.5488 17.7356C38.8155 18.5147 37.899 18.8813 36.7074 18.8813Z",
    fill: lightHeader ? "white" : darkHeader ? "#124680" : "white"
  }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
    d: "M90.3266 9.11892C88.9976 7.74407 87.2103 7.05664 85.0563 7.05664C82.9024 7.05664 81.1151 7.74407 79.7861 9.11892C78.457 10.4938 77.8154 12.3269 77.8154 14.5267C77.8154 16.7723 78.5029 18.5596 79.7861 19.9344C81.1151 21.3093 82.9024 21.9967 85.0563 21.9967C87.2103 21.9967 88.9976 21.3093 90.3266 19.9344C91.6556 18.5596 92.3431 16.7265 92.3431 14.5267C92.2972 12.3269 91.6098 10.4938 90.3266 9.11892ZM85.0563 18.9262C84.0023 18.9262 83.0857 18.5596 82.3066 17.8263C81.5275 17.1389 81.1151 15.9932 81.1151 14.5267C81.1151 13.0602 81.5275 11.9603 82.2608 11.227C83.0399 10.4938 83.9565 10.1271 85.0105 10.1271C86.0646 10.1271 86.9811 10.4938 87.7602 11.227C88.5393 11.9145 88.9059 13.0143 88.9059 14.5267C88.9059 15.9932 88.4935 17.1389 87.7602 17.8263C87.027 18.5596 86.1104 18.9262 85.0563 18.9262Z",
    fill: lightHeader ? "white" : darkHeader ? "#124680" : "white"
  }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
    d: "M107.788 12.6935V21.7676H104.443V12.9685C104.443 11.0437 103.664 10.173 101.968 10.173C100.593 10.173 99.3099 10.9521 98.0725 12.4186V21.7676H94.7271V7.33161H97.156L97.7976 9.07309C99.2182 7.74407 100.776 7.05664 102.564 7.05664C104.168 7.05664 105.451 7.60658 106.413 8.70647C107.33 9.76052 107.788 11.1354 107.788 12.6935Z",
    fill: lightHeader ? "white" : darkHeader ? "#124680" : "white"
  }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
    d: "M122.132 17.5981C120.849 18.423 119.474 18.8355 118.008 18.8355C116.541 18.8355 115.441 18.5147 114.754 17.9189C114.158 17.4148 113.791 16.7274 113.608 15.8108H123.782V14.0235C123.69 12.1445 123.14 10.5405 122.086 9.21149C120.941 7.74497 119.199 7.01172 116.999 7.01172C114.8 7.01172 113.104 7.74497 111.912 9.21149C110.767 10.678 110.171 12.5111 110.171 14.7109C110.171 16.9107 110.812 18.698 112.142 20.027C113.425 21.356 115.166 21.9976 117.32 21.9976C119.382 21.9976 121.261 21.5394 122.82 20.6686L123.003 20.6228L122.82 17.1856L122.132 17.5981ZM113.562 12.9694C113.7 12.0529 114.066 11.3654 114.616 10.9071C115.304 10.3114 116.083 10.0364 116.954 10.0364C117.824 10.0364 118.603 10.3114 119.291 10.9071C119.887 11.4113 120.253 12.0987 120.345 12.9694H113.562Z",
    fill: lightHeader ? "white" : darkHeader ? "#124680" : "white"
  }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
    d: "M139.18 7.33203L138.951 7.9278L130.656 27.909H127.219L129.694 21.5389L123.919 7.33203H127.494L131.481 17.3685L135.606 7.33203H139.18Z",
    fill: lightHeader ? "white" : darkHeader ? "#124680" : "white"
  }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
    d: "M46.2866 7.43108C46.2866 2.92739 49.214 0 53.7177 0H68.1858C72.6895 0 75.6169 2.92739 75.6169 7.43108V21.8992C75.6169 26.4028 72.6895 29.3302 68.1858 29.3302H53.7177C49.214 29.3302 46.2866 26.4028 46.2866 21.8992V7.43108Z",
    fill: "#ED1C24"
  }), /*#__PURE__*/(0,jsx_runtime.jsx)("mask", {
    id: "mask0_841_14902",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 46,
    y: 0,
    width: 30,
    height: 30,
    "data-test-id": "TripMoneyLogo-mask",
    children: /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      d: "M46.2866 7.43108C46.2866 2.92739 49.214 0 53.7177 0H68.1858C72.6895 0 75.6169 2.92739 75.6169 7.43108V21.8992C75.6169 26.4028 72.6895 29.3302 68.1858 29.3302H53.7177C49.214 29.3302 46.2866 26.4028 46.2866 21.8992V7.43108Z",
      fill: "#ED1C24"
    })
  }), /*#__PURE__*/(0,jsx_runtime.jsx)("g", {
    mask: "url(#mask0_841_14902)",
    children: /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      d: "M66.7918 14.4442C66.5085 15.7447 66.2613 19.2464 66.228 20.0858C66.1947 20.9251 66.4676 21.4404 67.1385 21.7724C67.7125 22.0566 68.2539 22.0493 68.7759 21.6781C68.9716 21.5389 68.6731 19.3183 68.7759 17.812C68.9895 14.6816 70.4515 9.95402 70.4515 9.95402L70.4557 9.92885C70.4818 9.77456 70.5076 9.62172 70.5076 9.49311C70.5076 8.68021 70.11 8.16544 69.2589 8.08418C68.3798 8.00267 67.9247 8.40948 67.131 9.33057C65.3705 11.4168 63.2701 14.5333 62.2771 15.9698C62.1643 16.1314 61.9651 16.0778 61.9651 15.8609C61.9651 15.2108 64.3308 8.27558 64.3308 8.27558C64.3308 8.27558 64.6093 7.32538 63.7975 6.99643C63.7975 6.99643 62.5787 6.2648 61.5449 7.71521L56.7454 13.9811C56.3686 14.4607 56.1816 14.2832 56.1816 14.2832C56.0645 14.2262 56.14 13.8688 56.14 13.8688L56.8968 9.78421C57.5026 6.64396 56.3486 6.47876 55.6272 6.38609C54.9062 6.29343 54.0405 6.81183 54.0405 6.81183C52.5402 7.53085 51.4081 10.3916 51.4081 10.3916C51.4081 10.3916 51.0689 11.4095 51.7836 11.802C51.7836 11.802 52.0552 12.0174 52.5824 11.999C53.6302 11.9621 53.8482 10.0549 54.6145 10.0549C54.757 10.0549 54.757 10.2175 54.757 10.2446L52.2785 20.2027C52.2785 20.2027 51.9945 21.1888 52.8982 21.7164C54.0538 22.3908 54.802 21.2698 54.802 21.2698L55.6687 19.9322C56.9921 17.7189 59.3906 14.5461 59.6457 14.5461C59.7311 14.5461 59.759 14.574 59.759 14.6541L58.9117 20.4897C58.9117 20.4897 58.7287 21.4556 59.6236 21.7724C59.6236 21.7724 60.4968 22.0648 60.9994 21.6781C60.9994 21.6781 61.6249 21.2735 62.2484 20.2971C62.7291 19.5441 65.1464 16.8279 66.6216 14.3356C66.7356 14.1728 66.8205 14.3082 66.7918 14.4442Z",
      fill: "white"
    })
  }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
    d: "M32.4 37.304L31.7584 35.7459H29.7877L29.192 37.304H28.5962L30.521 32.4004H31.0251L32.9499 37.304H32.4ZM31.6209 35.2418L31.0251 33.6836C31.0251 33.6378 30.9793 33.5919 30.9793 33.5003C30.9334 33.4086 30.9334 33.317 30.8876 33.2253C30.8418 33.1336 30.8418 33.042 30.796 32.9962C30.796 33.0878 30.7501 33.1795 30.7043 33.2711C30.6585 33.3628 30.6585 33.4544 30.6126 33.5003C30.5668 33.5919 30.5668 33.6378 30.5668 33.6836L29.971 35.2418H31.6209Z",
    fill: lightHeader ? "white" : darkHeader ? "#124680" : "white"
  }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
    d: "M37.6705 37.304L36.0206 32.9503H35.9748C35.9748 33.042 35.9748 33.1336 36.0206 33.2711C36.0206 33.4086 36.0206 33.5461 36.0206 33.6836C36.0206 33.8211 36.0206 34.0044 36.0206 34.1419V37.2582H35.4707V32.4004H36.3414L37.8996 36.4791H37.9454L39.5494 32.4004H40.3743V37.304H39.8244V34.1419C39.8244 34.0044 39.8244 33.8669 39.8244 33.6836C39.8244 33.5461 39.8244 33.4086 39.8244 33.2711C39.8244 33.1336 39.8244 33.042 39.8244 32.9503H39.7786L38.0829 37.304H37.6705V37.304Z",
    fill: lightHeader ? "white" : darkHeader ? "#124680" : "white"
  }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
    d: "M43.0317 33.5469C43.4899 33.5469 43.8107 33.6385 44.0399 33.8218C44.269 34.0052 44.3607 34.326 44.3607 34.7842V37.3048H43.9482L43.8566 36.7549H43.8107C43.7191 36.8924 43.5816 36.984 43.4899 37.0757C43.3983 37.1673 43.2608 37.2132 43.0775 37.259C42.94 37.3048 42.7567 37.3048 42.5275 37.3048C42.2984 37.3048 42.1151 37.259 41.9318 37.1673C41.7485 37.0757 41.611 36.984 41.5193 36.8007C41.4277 36.6632 41.3818 36.4341 41.3818 36.2049C41.3818 35.8383 41.5193 35.5633 41.8401 35.38C42.1151 35.1967 42.5734 35.0592 43.1691 35.0592L43.8107 35.0134V34.7842C43.8107 34.4634 43.7191 34.2343 43.5816 34.0968C43.4441 33.9593 43.2608 33.9135 42.9858 33.9135C42.8025 33.9135 42.6192 33.9593 42.4359 34.0052C42.2526 34.051 42.1151 34.1426 41.9318 34.1885L41.7485 33.776C41.9318 33.6844 42.1151 33.6385 42.3442 33.5469C42.5734 33.5927 42.8025 33.5469 43.0317 33.5469ZM43.7649 35.4717L43.215 35.5175C42.7567 35.5175 42.4359 35.6092 42.2526 35.7466C42.0693 35.8841 41.9776 36.0674 41.9776 36.2966C41.9776 36.5257 42.0234 36.6632 42.1609 36.7549C42.2984 36.8465 42.4817 36.8924 42.665 36.8924C42.9858 36.8924 43.2608 36.8007 43.4899 36.6174C43.7191 36.4341 43.8107 36.1591 43.8107 35.7925V35.4717H43.7649Z",
    fill: lightHeader ? "white" : darkHeader ? "#124680" : "white"
  }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
    d: "M46.0563 32.0801V34.784C46.0563 34.8756 46.0563 34.9673 46.0563 35.1048C46.0563 35.2422 46.0563 35.3339 46.0563 35.4256H46.1021C46.1479 35.3797 46.2396 35.2881 46.3313 35.1506C46.4229 35.0589 46.5146 34.9673 46.5604 34.8756L47.7978 33.5924H48.4394L46.927 35.1506L48.531 37.2587H47.8436L46.5146 35.5172L46.0563 35.9297V37.2587H45.5063V32.0801H46.0563Z",
    fill: lightHeader ? "white" : darkHeader ? "#124680" : "white"
  }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
    d: "M50.5937 33.5469C50.9145 33.5469 51.1895 33.6385 51.4187 33.776C51.6478 33.9135 51.8311 34.0968 51.9228 34.3718C52.0603 34.6009 52.1061 34.9217 52.1061 35.2425V35.6092H49.5397C49.5397 36.0216 49.6772 36.3882 49.8605 36.6174C50.0896 36.8465 50.3646 36.9382 50.7312 36.9382C50.9604 36.9382 51.1895 36.9382 51.3728 36.8924C51.5561 36.8465 51.7395 36.8007 51.9228 36.709V37.1215C51.7395 37.2132 51.5561 37.259 51.3728 37.3048C51.1895 37.3506 50.9604 37.3506 50.7312 37.3506C50.3646 37.3506 50.0438 37.259 49.8147 37.1215C49.5397 36.984 49.3564 36.7549 49.2189 36.4799C49.0814 36.2049 48.9897 35.8383 48.9897 35.4717C48.9897 35.0592 49.0356 34.7384 49.1731 34.4634C49.3105 34.1885 49.4939 33.9593 49.723 33.776C49.9521 33.6385 50.2271 33.5469 50.5937 33.5469ZM50.5479 34.0052C50.2271 34.0052 49.998 34.0968 49.8147 34.2801C49.6313 34.4634 49.5397 34.7384 49.4939 35.105H51.4645C51.4645 34.8759 51.4187 34.6926 51.3728 34.5093C51.327 34.326 51.1895 34.2343 51.052 34.1426C50.9604 34.051 50.7771 34.0052 50.5479 34.0052Z",
    fill: lightHeader ? "white" : darkHeader ? "#124680" : "white"
  }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
    d: "M55.314 37.304L53.6642 32.9503H53.6184C53.6184 33.042 53.6184 33.1336 53.6642 33.2711C53.6642 33.4086 53.6642 33.5461 53.6642 33.6836C53.6642 33.8211 53.6642 34.0044 53.6642 34.1419V37.2582H53.1143V32.4004H53.985L55.5432 36.4791H55.589L57.193 32.4004H58.0179V37.304H57.468V34.1419C57.468 34.0044 57.468 33.8669 57.468 33.6836C57.468 33.5461 57.468 33.4086 57.468 33.2711C57.468 33.1336 57.468 33.042 57.468 32.9503L55.7723 37.304H55.314V37.304Z",
    fill: lightHeader ? "white" : darkHeader ? "#124680" : "white"
  }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
    d: "M58.7051 33.6387H59.3008L60.1258 35.7926C60.1716 35.9301 60.2174 36.0218 60.2632 36.1592C60.3091 36.2509 60.3549 36.3884 60.3549 36.48C60.3549 36.5717 60.4007 36.7092 60.4466 36.8008H60.4924C60.5382 36.7092 60.584 36.5259 60.6299 36.3426C60.6757 36.1592 60.7674 35.9759 60.8132 35.7926L61.5923 33.6845H62.188L60.584 37.9007C60.4924 38.1299 60.4007 38.3132 60.2632 38.4965C60.1716 38.6798 60.0341 38.7715 59.8508 38.8631C59.6675 38.9548 59.4842 39.0006 59.255 39.0006C59.1634 39.0006 59.0717 39.0006 58.9801 39.0006C58.8884 39.0006 58.8426 38.9548 58.7509 38.9548V38.4965C58.7967 38.4965 58.8426 38.4965 58.9342 38.5423C59.0259 38.5423 59.0717 38.5423 59.1634 38.5423C59.3008 38.5423 59.4383 38.4965 59.53 38.4507C59.6216 38.4048 59.7133 38.3132 59.805 38.2215C59.8966 38.1299 59.9424 37.9924 59.9883 37.8549L60.1716 37.3508L58.7051 33.6387Z",
    fill: lightHeader ? "white" : darkHeader ? "#124680" : "white"
  }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
    d: "M64.3873 37.304H63.7916V32.9045H62.2334V32.4004H65.9455V32.9045H64.3873V37.304V37.304Z",
    fill: lightHeader ? "white" : darkHeader ? "#124680" : "white"
  }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
    d: "M68.2831 33.5469C68.3747 33.5469 68.4205 33.5469 68.5122 33.5469C68.6039 33.5469 68.6497 33.5469 68.7413 33.5927L68.6497 34.0968C68.6039 34.0968 68.5122 34.051 68.4664 34.051C68.3747 34.051 68.3289 34.051 68.2372 34.051C68.0997 34.051 67.9623 34.0968 67.8248 34.1426C67.6873 34.1885 67.5956 34.2801 67.4581 34.4176C67.3665 34.5093 67.2748 34.6468 67.229 34.8301C67.1832 34.9676 67.1373 35.1509 67.1373 35.3342V37.3048H66.5874V33.6385H67.0457L67.0915 34.326H67.1373C67.229 34.1885 67.3207 34.051 67.4123 33.9593C67.504 33.8677 67.6415 33.776 67.7789 33.6844C67.9623 33.5927 68.0997 33.5469 68.2831 33.5469Z",
    fill: lightHeader ? "white" : darkHeader ? "#124680" : "white"
  }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
    d: "M69.9796 33.6385V37.3048H69.4296V33.6385H69.9796ZM69.7046 32.2637C69.7962 32.2637 69.8879 32.3095 69.9337 32.3553C69.9796 32.4012 70.0254 32.4928 70.0254 32.6303C70.0254 32.7678 69.9796 32.8594 69.9337 32.9053C69.8879 32.9511 69.7962 32.9969 69.7046 32.9969C69.6129 32.9969 69.5213 32.9511 69.4754 32.9053C69.4296 32.8594 69.3838 32.7678 69.3838 32.6303C69.3838 32.4928 69.4296 32.4012 69.4754 32.3553C69.5671 32.2637 69.6129 32.2637 69.7046 32.2637Z",
    fill: lightHeader ? "white" : darkHeader ? "#124680" : "white"
  }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
    d: "M72.9583 33.5469C73.4166 33.5469 73.7832 33.6844 74.0582 34.0052C74.3331 34.326 74.4706 34.7842 74.4706 35.4258C74.4706 35.8383 74.4248 36.2049 74.2873 36.4799C74.1498 36.7549 73.9665 36.984 73.7374 37.1215C73.5082 37.259 73.2332 37.3506 72.9124 37.3506C72.7291 37.3506 72.5458 37.3048 72.4083 37.259C72.2709 37.2132 72.1334 37.1215 72.0417 37.0298C71.9501 36.9382 71.8584 36.8465 71.7667 36.7549H71.7209C71.7209 36.8465 71.7209 36.9382 71.7667 37.0757C71.7667 37.2132 71.7667 37.3048 71.7667 37.3965V38.9546H71.2168V33.6385H71.6751L71.7667 34.1885H71.8126C71.9042 34.0968 71.95 33.9593 72.0875 33.8677C72.1792 33.776 72.3167 33.6844 72.4542 33.6385C72.5458 33.5927 72.7291 33.5469 72.9583 33.5469ZM72.8208 34.0052C72.5458 34.0052 72.3625 34.051 72.1792 34.1426C72.0417 34.2343 71.9042 34.3718 71.8584 34.6009C71.7667 34.7842 71.7667 35.0592 71.7209 35.3342V35.4258C71.7209 35.7466 71.7667 36.0216 71.8126 36.2049C71.9042 36.4341 71.9959 36.5716 72.1334 36.709C72.3167 36.8007 72.5 36.8924 72.775 36.8924C73.0041 36.8924 73.1874 36.8465 73.3707 36.709C73.5082 36.5716 73.6457 36.4341 73.6915 36.2049C73.7832 35.9758 73.829 35.7466 73.829 35.4258C73.829 35.0134 73.7374 34.6468 73.5541 34.3718C73.4624 34.1426 73.1874 34.0052 72.8208 34.0052Z",
    fill: lightHeader ? "white" : darkHeader ? "#124680" : "white"
  }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
    d: "M79.4661 34.7375H81.2076V37.1206C80.9326 37.2122 80.6576 37.2581 80.3827 37.3039C80.1077 37.3497 79.7869 37.3497 79.4661 37.3497C78.962 37.3497 78.5037 37.2581 78.1829 37.0289C77.8163 36.8456 77.5413 36.5248 77.358 36.1582C77.1747 35.7916 77.083 35.3333 77.083 34.8292C77.083 34.325 77.1747 33.8668 77.4038 33.5001C77.5871 33.1335 77.9079 32.8127 78.2745 32.6294C78.6412 32.4002 79.0995 32.3086 79.6494 32.3086C79.9244 32.3086 80.1993 32.3544 80.4285 32.4002C80.6576 32.4461 80.8868 32.5377 81.1159 32.6294L80.8868 33.1335C80.7035 33.0419 80.5201 32.996 80.291 32.9502C80.0619 32.9044 79.8327 32.8585 79.6036 32.8585C79.1911 32.8585 78.8703 32.9502 78.5495 33.0877C78.2745 33.271 78.0454 33.5001 77.9079 33.7751C77.7704 34.0959 77.6788 34.4167 77.6788 34.8292C77.6788 35.2416 77.7246 35.6082 77.8621 35.8832C77.9996 36.204 78.1829 36.4332 78.5037 36.5706C78.7787 36.754 79.1453 36.7998 79.6036 36.7998C79.8327 36.7998 80.016 36.7998 80.1993 36.754C80.3827 36.7081 80.5201 36.7081 80.6576 36.6623V35.15H79.4661V34.7375Z",
    fill: lightHeader ? "white" : darkHeader ? "#124680" : "white"
  }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
    d: "M84.0023 33.5469C84.094 33.5469 84.1398 33.5469 84.2314 33.5469C84.3231 33.5469 84.3689 33.5469 84.4606 33.5927L84.3689 34.0968C84.3231 34.0968 84.2314 34.051 84.1856 34.051C84.094 34.051 84.0481 34.051 83.9565 34.051C83.819 34.051 83.6815 34.0968 83.544 34.1426C83.4065 34.1885 83.3149 34.2801 83.1774 34.4176C83.0857 34.5093 82.9941 34.6468 82.9482 34.8301C82.9024 34.9676 82.8566 35.1509 82.8566 35.3342V37.3048H82.3066V33.6385H82.7649L82.8108 34.326H82.8566C82.9482 34.1885 83.0399 34.051 83.1316 33.9593C83.2232 33.8677 83.3607 33.776 83.4982 33.6844C83.6357 33.5927 83.819 33.5469 84.0023 33.5469Z",
    fill: lightHeader ? "white" : darkHeader ? "#124680" : "white"
  }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
    d: "M88.357 35.4708C88.357 35.7916 88.3112 36.0207 88.2195 36.2957C88.1278 36.5248 88.0362 36.754 87.8987 36.8914C87.7612 37.0748 87.5779 37.1664 87.3488 37.2581C87.1196 37.3497 86.8905 37.3956 86.6155 37.3956C86.3864 37.3956 86.1572 37.3497 85.9281 37.2581C85.7448 37.1664 85.5614 37.0289 85.3781 36.8914C85.2406 36.7081 85.1032 36.5248 85.0115 36.2957C84.9199 36.0665 84.874 35.7916 84.874 35.4708C84.874 35.0583 84.9657 34.7375 85.1032 34.4625C85.2407 34.1876 85.424 33.9584 85.6989 33.8209C85.9739 33.6835 86.2489 33.5918 86.6155 33.5918C86.9363 33.5918 87.2571 33.6835 87.4862 33.8209C87.7612 33.9584 87.9445 34.1876 88.082 34.4625C88.2653 34.6917 88.357 35.0583 88.357 35.4708ZM85.5156 35.4708C85.5156 35.7457 85.5614 36.0207 85.6531 36.2498C85.7448 36.479 85.8364 36.6165 86.0197 36.754C86.203 36.8914 86.3864 36.9373 86.6613 36.9373C86.9363 36.9373 87.1196 36.8914 87.3029 36.754C87.4862 36.6165 87.5779 36.479 87.6696 36.2498C87.7612 36.0207 87.807 35.7916 87.807 35.4708C87.807 35.1958 87.7612 34.9208 87.6696 34.6917C87.5779 34.4625 87.4862 34.3251 87.3029 34.1876C87.1196 34.0501 86.9363 34.0043 86.6613 34.0043C86.2947 34.0043 85.9739 34.1417 85.7906 34.3709C85.6073 34.6459 85.5156 35.0125 85.5156 35.4708Z",
    fill: lightHeader ? "white" : darkHeader ? "#124680" : "white"
  }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
    d: "M92.3888 33.6385V37.3048H91.9305L91.8389 36.8007C91.7472 36.9382 91.6555 37.0298 91.5181 37.1215C91.3806 37.2132 91.2431 37.259 91.1056 37.3048C90.9681 37.3506 90.7848 37.3506 90.6015 37.3506C90.3265 37.3506 90.0515 37.3048 89.8682 37.2132C89.6849 37.1215 89.5016 36.984 89.4099 36.7549C89.3183 36.5716 89.2725 36.2966 89.2725 35.9758V33.5469H89.8224V35.93C89.8224 36.2508 89.9141 36.4799 90.0516 36.6174C90.189 36.7549 90.4182 36.8465 90.6931 36.8465C90.9681 36.8465 91.1973 36.8007 91.3347 36.709C91.5181 36.6174 91.6097 36.4341 91.7014 36.2508C91.793 36.0674 91.793 35.7925 91.793 35.5175V33.5927H92.3888V33.6385Z",
    fill: lightHeader ? "white" : darkHeader ? "#124680" : "white"
  }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
    d: "M95.323 33.5469C95.7813 33.5469 96.1479 33.6844 96.4229 34.0052C96.6979 34.326 96.8354 34.7842 96.8354 35.4258C96.8354 35.8383 96.7895 36.2049 96.6521 36.4799C96.5146 36.7549 96.3313 36.984 96.1021 37.1215C95.873 37.259 95.598 37.3506 95.2772 37.3506C95.0939 37.3506 94.9106 37.3048 94.7731 37.259C94.6356 37.2132 94.4981 37.1215 94.4065 37.0298C94.3148 36.9382 94.2231 36.8465 94.1315 36.7549H94.0857C94.0857 36.8465 94.0857 36.9382 94.1315 37.0757C94.1315 37.2132 94.1315 37.3048 94.1315 37.3965V38.9546H93.5815V33.6385H94.0398L94.1315 34.1885H94.1773C94.269 34.0968 94.3148 33.9593 94.4523 33.8677C94.5439 33.776 94.6814 33.6844 94.8189 33.6385C94.9564 33.5927 95.1397 33.5469 95.323 33.5469ZM95.2314 34.0052C94.9564 34.0052 94.7731 34.051 94.5898 34.1426C94.4523 34.2343 94.3148 34.3718 94.269 34.6009C94.1773 34.7842 94.1773 35.0592 94.1315 35.3342V35.4258C94.1315 35.7466 94.1773 36.0216 94.2231 36.2049C94.3148 36.4341 94.4065 36.5716 94.5439 36.709C94.7273 36.8007 94.9106 36.8924 95.1855 36.8924C95.4147 36.8924 95.598 36.8465 95.7813 36.709C95.9188 36.5716 96.0563 36.4341 96.1021 36.2049C96.1938 35.9758 96.2396 35.7466 96.2396 35.4258C96.2396 35.0134 96.1479 34.6468 95.9646 34.3718C95.8271 34.1426 95.598 34.0052 95.2314 34.0052Z",
    fill: lightHeader ? "white" : darkHeader ? "#124680" : "white"
  }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
    d: "M101.83 32.8127C101.555 32.8127 101.326 32.8585 101.097 32.9502C100.868 33.0419 100.684 33.1793 100.547 33.3627C100.409 33.546 100.272 33.7293 100.18 34.0042C100.088 34.2334 100.043 34.5542 100.043 34.8292C100.043 35.2416 100.088 35.6082 100.226 35.8832C100.363 36.204 100.547 36.4332 100.822 36.5706C101.097 36.754 101.417 36.7998 101.784 36.7998C102.013 36.7998 102.197 36.7998 102.426 36.754C102.609 36.7081 102.792 36.6623 103.021 36.6165V37.1206C102.838 37.1664 102.655 37.2581 102.472 37.2581C102.288 37.3039 102.059 37.3039 101.784 37.3039C101.28 37.3039 100.868 37.2122 100.501 36.9831C100.18 36.754 99.9051 36.479 99.7218 36.1124C99.5385 35.7457 99.4927 35.2874 99.4927 34.7833C99.4927 34.4167 99.5385 34.0959 99.6302 33.7751C99.7218 33.4543 99.9051 33.1793 100.088 32.996C100.272 32.7669 100.547 32.5836 100.822 32.4919C101.097 32.3544 101.463 32.3086 101.83 32.3086C102.059 32.3086 102.334 32.3544 102.563 32.4002C102.792 32.4461 103.021 32.5377 103.205 32.6294L102.976 33.1335C102.838 33.0419 102.655 32.996 102.472 32.9502C102.242 32.8585 102.059 32.8127 101.83 32.8127Z",
    fill: lightHeader ? "white" : darkHeader ? "#124680" : "white"
  }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
    d: "M107.238 35.4708C107.238 35.7916 107.192 36.0207 107.1 36.2957C107.009 36.5248 106.917 36.754 106.78 36.8914C106.642 37.0748 106.459 37.1664 106.23 37.2581C106 37.3497 105.771 37.3956 105.496 37.3956C105.267 37.3956 105.038 37.3497 104.809 37.2581C104.626 37.1664 104.442 37.0289 104.259 36.8914C104.122 36.7081 103.984 36.5248 103.892 36.2957C103.801 36.0665 103.755 35.7916 103.755 35.4708C103.755 35.0583 103.847 34.7375 103.984 34.4625C104.122 34.1876 104.305 33.9584 104.58 33.8209C104.855 33.6835 105.13 33.5918 105.496 33.5918C105.817 33.5918 106.138 33.6835 106.367 33.8209C106.642 33.9584 106.825 34.1876 106.963 34.4625C107.146 34.6917 107.238 35.0583 107.238 35.4708ZM104.396 35.4708C104.396 35.7457 104.442 36.0207 104.534 36.2498C104.626 36.479 104.717 36.6165 104.901 36.754C105.084 36.8914 105.267 36.9373 105.542 36.9373C105.817 36.9373 106 36.8914 106.184 36.754C106.367 36.6165 106.459 36.479 106.55 36.2498C106.642 36.0207 106.688 35.7916 106.688 35.4708C106.688 35.1958 106.642 34.9208 106.55 34.6917C106.459 34.4625 106.367 34.3251 106.184 34.1876C106 34.0501 105.817 34.0043 105.542 34.0043C105.176 34.0043 104.855 34.1417 104.671 34.3709C104.488 34.6459 104.396 35.0125 104.396 35.4708Z",
    fill: lightHeader ? "white" : darkHeader ? "#124680" : "white"
  }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
    d: "M112.234 33.5469C112.646 33.5469 112.967 33.6385 113.15 33.8677C113.379 34.0968 113.471 34.4176 113.471 34.8759V37.3048H112.921V34.9217C112.921 34.6468 112.875 34.4176 112.738 34.2343C112.6 34.0968 112.417 34.0052 112.142 34.0052C111.775 34.0052 111.5 34.0968 111.363 34.326C111.18 34.5093 111.134 34.8301 111.134 35.2425V37.3048H110.584V34.9217C110.584 34.7384 110.538 34.5551 110.492 34.4176C110.446 34.2801 110.355 34.1885 110.217 34.1426C110.126 34.0968 109.942 34.051 109.805 34.051C109.576 34.051 109.346 34.0968 109.209 34.1885C109.071 34.2801 108.934 34.4176 108.888 34.6468C108.842 34.8301 108.797 35.105 108.797 35.38V37.3048H108.247V33.6385H108.705L108.797 34.1426H108.842C108.934 34.0052 109.026 33.9135 109.117 33.8218C109.209 33.7302 109.346 33.6844 109.484 33.6385C109.621 33.5927 109.759 33.5927 109.942 33.5927C110.217 33.5927 110.446 33.6385 110.63 33.7302C110.813 33.8218 110.95 34.0052 111.042 34.1885H111.088C111.225 33.9593 111.363 33.8218 111.592 33.7302C111.73 33.5927 111.959 33.5469 112.234 33.5469Z",
    fill: lightHeader ? "white" : darkHeader ? "#124680" : "white"
  }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
    d: "M116.357 33.5469C116.815 33.5469 117.182 33.6844 117.457 34.0052C117.732 34.326 117.87 34.7842 117.87 35.4258C117.87 35.8383 117.824 36.2049 117.686 36.4799C117.549 36.7549 117.365 36.984 117.136 37.1215C116.907 37.259 116.632 37.3506 116.311 37.3506C116.128 37.3506 115.945 37.3048 115.807 37.259C115.67 37.2132 115.532 37.1215 115.441 37.0298C115.349 36.9382 115.257 36.8465 115.166 36.7549H115.12C115.12 36.8465 115.12 36.9382 115.166 37.0757C115.166 37.2132 115.166 37.3048 115.166 37.3965V38.9546H114.616V33.6385H115.074L115.166 34.1885H115.211C115.303 34.0968 115.395 33.9593 115.486 33.8677C115.578 33.776 115.716 33.6844 115.853 33.6385C115.991 33.5927 116.174 33.5469 116.357 33.5469ZM116.266 34.0052C115.991 34.0052 115.807 34.051 115.624 34.1426C115.486 34.2343 115.349 34.3718 115.303 34.6009C115.211 34.7842 115.211 35.0592 115.166 35.3342V35.4258C115.166 35.7466 115.211 36.0216 115.257 36.2049C115.349 36.4341 115.441 36.5716 115.578 36.709C115.761 36.8007 115.945 36.8924 116.22 36.8924C116.449 36.8924 116.632 36.8465 116.815 36.709C116.953 36.5716 117.09 36.4341 117.136 36.2049C117.228 35.9758 117.274 35.7466 117.274 35.4258C117.274 35.0134 117.182 34.6468 116.999 34.3718C116.861 34.1426 116.632 34.0052 116.266 34.0052Z",
    fill: lightHeader ? "white" : darkHeader ? "#124680" : "white"
  }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
    d: "M120.252 33.5469C120.711 33.5469 121.031 33.6385 121.261 33.8218C121.49 34.0052 121.581 34.326 121.581 34.7842V37.3048H121.169L121.077 36.7549H121.031C120.94 36.8924 120.802 36.984 120.711 37.0757C120.619 37.1673 120.482 37.2132 120.298 37.259C120.161 37.3048 119.977 37.3048 119.748 37.3048C119.519 37.3048 119.336 37.259 119.152 37.1673C118.969 37.0757 118.832 36.984 118.74 36.8007C118.648 36.6632 118.603 36.4341 118.603 36.2049C118.603 35.8383 118.74 35.5633 119.061 35.38C119.336 35.1967 119.794 35.0592 120.39 35.0592L121.031 35.0134V34.7842C121.031 34.4634 120.986 34.2343 120.802 34.0968C120.665 33.9593 120.482 33.9135 120.207 33.9135C120.023 33.9135 119.84 33.9593 119.657 34.0052C119.473 34.051 119.29 34.1426 119.152 34.1885L118.969 33.776C119.152 33.6844 119.336 33.6385 119.565 33.5469C119.794 33.5927 120.023 33.5469 120.252 33.5469ZM121.031 35.4717L120.482 35.5175C120.023 35.5175 119.702 35.6092 119.519 35.7466C119.336 35.8841 119.244 36.0674 119.244 36.2966C119.244 36.5257 119.29 36.6632 119.427 36.7549C119.565 36.8465 119.748 36.8924 119.932 36.8924C120.252 36.8924 120.527 36.8007 120.756 36.6174C120.986 36.4341 121.077 36.1591 121.077 35.7925V35.4717H121.031Z",
    fill: lightHeader ? "white" : darkHeader ? "#124680" : "white"
  }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
    d: "M124.47 33.5469C124.928 33.5469 125.249 33.6385 125.478 33.8677C125.707 34.0968 125.799 34.4176 125.799 34.8759V37.259H125.294V34.9217C125.294 34.6009 125.203 34.3718 125.065 34.2343C124.928 34.0968 124.699 34.0052 124.424 34.0052C124.011 34.0052 123.736 34.1426 123.553 34.3718C123.37 34.6009 123.324 34.9217 123.324 35.38V37.3048H122.774V33.6385H123.232L123.324 34.1885H123.37C123.461 34.051 123.553 33.9593 123.69 33.8677C123.828 33.776 123.965 33.7302 124.103 33.6844C124.149 33.5927 124.332 33.5469 124.47 33.5469Z",
    fill: lightHeader ? "white" : darkHeader ? "#124680" : "white"
  }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
    d: "M126.394 33.6387H126.989L127.814 35.7926C127.86 35.9301 127.906 36.0218 127.952 36.1592C127.998 36.2509 128.043 36.3884 128.043 36.48C128.043 36.5717 128.089 36.7092 128.135 36.8008H128.181C128.227 36.7092 128.273 36.5259 128.318 36.3426C128.364 36.1592 128.456 35.9759 128.502 35.7926L129.281 33.6845H129.877L128.273 37.9007C128.181 38.1299 128.089 38.3132 127.952 38.4965C127.86 38.6798 127.723 38.7715 127.539 38.8631C127.356 38.9548 127.173 39.0006 126.944 39.0006C126.852 39.0006 126.76 39.0006 126.669 39.0006C126.577 39.0006 126.531 38.9548 126.439 38.9548V38.4965C126.485 38.4965 126.531 38.4965 126.623 38.5423C126.714 38.5423 126.76 38.5423 126.852 38.5423C126.989 38.5423 127.127 38.4965 127.218 38.4507C127.31 38.4048 127.402 38.3132 127.493 38.2215C127.585 38.1299 127.631 37.9924 127.677 37.8549L127.86 37.3508L126.394 33.6387Z",
    fill: lightHeader ? "white" : darkHeader ? "#124680" : "white"
  })]
});


;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/icons/index.ts











/***/ }),

/***/ 63646:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Bk": () => (/* binding */ InsuranceGiLandingPageMainWrapper),
/* harmony export */   "Dw": () => (/* binding */ GiFooterWrap),
/* harmony export */   "EL": () => (/* binding */ HorizontalDivider),
/* harmony export */   "Pc": () => (/* binding */ LandingPageRightWrapper),
/* harmony export */   "js": () => (/* binding */ PersuasionWrapper),
/* harmony export */   "lg": () => (/* binding */ InsuranceLandingMyBizPageMainWrapper),
/* harmony export */   "wB": () => (/* binding */ InsuranceLandingMyPartnerPageMainWrapper),
/* harmony export */   "x1": () => (/* binding */ InsuranceLandingPageMainWrapper)
/* harmony export */ });
/* harmony import */ var _tm_isomorphic_utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(44928);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(82740);
/* harmony import */ var _components_TextStyles_TextStyles_style__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(93139);



const InsuranceLandingPageMainWrapper = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "InsuranceLandingstyle__InsuranceLandingPageMainWrapper",
  componentId: "ez5p7u-0"
})(["background-image:linear-gradient(rgba(5,19,34,1),rgba(21,69,124,1));background-size:100% 990px;background-repeat:no-repeat;padding-top:16px;position:relative;z-index:2;@media ", "{background-image:none;padding-top:0px;}"], _tm_isomorphic_utils__WEBPACK_IMPORTED_MODULE_0__.deviceType.mobile);
const InsuranceLandingMyPartnerPageMainWrapper = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "InsuranceLandingstyle__InsuranceLandingMyPartnerPageMainWrapper",
  componentId: "ez5p7u-1"
})(["background-image:linear-gradient(180deg,#282a47 0.38%,#554276 100%);background-size:100% 990px;background-repeat:no-repeat;padding-top:16px;position:relative;z-index:2;.userSection{img,picture{flex-shrink:1;}}@media ", "{background-image:none;padding-top:0px;}"], _tm_isomorphic_utils__WEBPACK_IMPORTED_MODULE_0__.deviceType.mobile);
const InsuranceLandingMyBizPageMainWrapper = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "InsuranceLandingstyle__InsuranceLandingMyBizPageMainWrapper",
  componentId: "ez5p7u-2"
})(["background-image:linear-gradient( 178.99deg,#ffcbcb -28%,rgba(255,255,255,0) 57.04% );background-size:100% 990px;background-repeat:no-repeat;padding-top:16px;position:relative;z-index:2;@media ", "{background-image:none;padding-top:0px;}"], _tm_isomorphic_utils__WEBPACK_IMPORTED_MODULE_0__.deviceType.mobile);
const InsuranceGiLandingPageMainWrapper = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "InsuranceLandingstyle__InsuranceGiLandingPageMainWrapper",
  componentId: "ez5p7u-3"
})(["padding-top:16px;position:relative;z-index:2;&:after{content:\"\";position:absolute;top:240px;width:100%;left:0;background-color:#eff3f8;height:1200px;z-index:1;}:before{content:\"\";position:absolute;top:0;width:100%;left:0;background-image:url(\"https://tripmoneycmsimgak.mmtcdn.com/img/Group_1244831888_401a4765df.png\");background-size:100% 382px;background-repeat:no-repeat;height:382px;z-index:2;}@media ", "{background-image:none;padding-top:0px;&:after{background-color:transparent;}}"], _tm_isomorphic_utils__WEBPACK_IMPORTED_MODULE_0__.deviceType.mobile);
const PersuasionWrapper = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "InsuranceLandingstyle__PersuasionWrapper",
  componentId: "ez5p7u-4"
})(["width:1200px;margin:0 auto;", "{max-width:60%;}"], _components_TextStyles_TextStyles_style__WEBPACK_IMPORTED_MODULE_2__/* .H3TagStyle */ .KO);
const LandingPageRightWrapper = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "InsuranceLandingstyle__LandingPageRightWrapper",
  componentId: "ez5p7u-5"
})(["display:flex;flex-direction:column;gap:24px;margin-top:", ";@media ", "{margin-top:0px;}"], props => props.rightCompMargin ? "50px" : "0px", _tm_isomorphic_utils__WEBPACK_IMPORTED_MODULE_0__.deviceType.mobile);
const GiFooterWrap = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "InsuranceLandingstyle__GiFooterWrap",
  componentId: "ez5p7u-6"
})(["width:100%;"]);
const HorizontalDivider = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "InsuranceLandingstyle__HorizontalDivider",
  componentId: "ez5p7u-7"
})(["", ";", ";", ";"], props => `height: ${props.height}`, props => `width: ${props.width}`, props => `background-color: ${props.backgroundColor}`);

/***/ }),

/***/ 58524:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "L": () => (/* binding */ PartnerContextProvider),
/* harmony export */   "X": () => (/* binding */ usePartnerContext)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(52322);


const PartnerContext = /*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_0__.createContext)(null);
const usePartnerContext = () => {
  const context = (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(PartnerContext);

  if (context === null) {
    console.error("usePartnerContext must be used within a PartnerContextProvider");
  }

  return context;
};
const PartnerContextProvider = ({
  hostname,
  children,
  partnerType
}) => {
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(PartnerContext.Provider, {
    value: partnerType,
    children: children
  });
};

/***/ }),

/***/ 84576:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "GZ": () => (/* binding */ processCountryDataFromQuery),
/* harmony export */   "Ho": () => (/* binding */ isHostMakemytrip),
/* harmony export */   "IZ": () => (/* binding */ calendarLabelFormatter),
/* harmony export */   "P9": () => (/* binding */ convertUnixToDate),
/* harmony export */   "aB": () => (/* binding */ getInitialCountryData),
/* harmony export */   "cJ": () => (/* binding */ convertDateToUnix),
/* harmony export */   "gg": () => (/* binding */ MONTHS),
/* harmony export */   "lv": () => (/* binding */ DATE_FORMATS),
/* harmony export */   "p6": () => (/* binding */ formatDate),
/* harmony export */   "sI": () => (/* binding */ generateSourceSetImageUrl),
/* harmony export */   "vH": () => (/* binding */ LONG_WEEK_DAYS),
/* harmony export */   "vO": () => (/* binding */ deviceType)
/* harmony export */ });
/* unused harmony exports breakpoint, randomDayData, dayAdditionalData, SHORT_WEEK_DAYS, mfActiveTypeMatch, insertBrOnNewLine, isOnServer, TRIPMONEY_MMT_DOMAIN_NAMES */
/* harmony import */ var _opt_jenkins_workspace_TripMoney_Node_16_CDN_Docker_Submit_GitHub_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(95235);


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_opt_jenkins_workspace_TripMoney_Node_16_CDN_Docker_Submit_GitHub_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

// RESPONSIVE BREAKPOINTS
const breakpoint = {
  mobile: 768
};
const deviceType = {
  mobile: `(max-width: ${breakpoint.mobile}px)`,
  desktop: `(min-width: ${breakpoint.mobile}px)`
}; // CALENDAR UTILITY FUNCTIONS

const randomDayData = () => {
  const min = 10000;
  const max = 15000;
  const randomNum = Math.floor(Math.random() * (max - min + 1) + min);
  return {
    price: `₹${randomNum}`,
    class: randomNum <= 12000 ? "greenText" : "redText",
    isSoldOut: randomNum > 12000 && randomNum < 13000,
    availableOnPreviousDate: randomNum >= 13000 && randomNum <= 13500
  };
};
const dayAdditionalData = new Array(31).fill(0).map(() => randomDayData());
const MONTHS = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sept", "Oct", "Nov", "Dec"];
const SHORT_WEEK_DAYS = (/* unused pure expression or super */ null && (["Sun", "Mon", "Tue", "Wed", "Thurs", "Fri", "Sat"]));
const LONG_WEEK_DAYS = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
const mfActiveTypeMatch = {
  0: "Option 1",
  1: "Option 2",
  2: "Option 3"
}; // FOR DISPAYING INSIDE THE CALENDAR

const calendarLabelFormatter = dateObj => {
  return dateObj ? `${dateObj.getDate()} ${MONTHS[dateObj.getMonth()]}' ${dateObj.getFullYear().toString().slice(-2)}` : `${new Date().getDate()} ${MONTHS[new Date().getMonth()]}' ${new Date().getFullYear().toString().slice(-2)}`;
};
const insertBrOnNewLine = text => {
  return text.replace(/\n/g, "<br/>");
};
insertBrOnNewLine("hello he\nyello");
const generateSourceSetImageUrl = (cdnUrlWidths, imgUrl, width) => {
  let imgWidths = cdnUrlWidths;
  if (!imgWidths || !Array.isArray(imgWidths) || imgWidths.length === 0) imgWidths = [width, width * 2, width * 3];
  return imgWidths.map(width => `${imgUrl}?im=Resize=(${width}) ${width}w`).join(",");
};
const convertDateToUnix = date => {
  return Math.floor(new Date(date).getTime() / 1000);
};
const convertUnixToDate = unix => {
  return new Date(unix * 1000);
};
let DATE_FORMATS;

(function (DATE_FORMATS) {
  DATE_FORMATS["DDD"] = "ddd";
  DATE_FORMATS["YY"] = "yy";
  DATE_FORMATS["YYYY"] = "yyyy";
  DATE_FORMATS["D MMM"] = "d MMM";
  DATE_FORMATS["DD/MM/YYYY"] = "dd/MM/yyyy";
  DATE_FORMATS["DD MMM YY"] = "dd MMM'yy";
})(DATE_FORMATS || (DATE_FORMATS = {}));

const MONTHS_SHORT = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
const formatDate = (date, format) => {
  try {
    date = new Date(date);

    switch (format) {
      case DATE_FORMATS["DD MMM YY"]:
        return `${date.getDate()} ${MONTHS_SHORT[date.getMonth()]}'${date.getFullYear().toString().substr(-2)}`;

      default:
        return;
    }
  } catch (error) {
    console.log("Error in formatting given date", date, format);
  }

  return;
};
/* istanbul ignore next */

const isOnServer = () => {
  if (false) {}

  return false;
};
const TRIPMONEY_MMT_DOMAIN_NAMES = ["tripmoney.makemytrip.com", "www.makemytrip.com"];
/* istanbul ignore next */

const isHostMakemytrip = () => {
  if (isOnServer()) return false;
  const url = new URL(window.location.href);
  return TRIPMONEY_MMT_DOMAIN_NAMES.includes(url.hostname);
}; // COUNTRY DATA UTILITIES

/**
 * Generates initial country data with selected countries based on URL parameters or upcoming trip
 * @param countryList - Array of country objects from the travel form info
 * @param urlCountryCodes - Array of country codes from URL parameters
 * @param upcomingTrip - Upcoming trip data containing countryCode
 * @returns Array of countries with isSelected and isDisabled properties
 */
const getInitialCountryData = (countryList, urlCountryCodes = [], upcomingTrip, prePopulatedData, isCommonLandingRevamp, selectedTripOption) => {
  if (!countryList || !Array.isArray(countryList)) {
    return [];
  } // Initialize all countries with isSelected: false and isDisabled: false


  let initialCountryData = countryList.map(country => _objectSpread(_objectSpread({}, country), {}, {
    isSelected: false,
    isDisabled: false
  })); // If URL has country codes, mark those as selected

  if (urlCountryCodes.length > 0) {
    if (isCommonLandingRevamp && selectedTripOption === "MULTITRIP") {
      const multiCountryCode = urlCountryCodes.includes("USA") || urlCountryCodes.includes("CAN") || urlCountryCodes.includes("WW") ? ["WW"] : ["WWEUC"];
      initialCountryData = initialCountryData.map(country => {
        if (multiCountryCode.includes(country.code)) {
          return _objectSpread(_objectSpread({}, country), {}, {
            isSelected: true
          });
        }

        return _objectSpread({}, country);
      });
    } else {
      initialCountryData = initialCountryData.map(country => {
        if (urlCountryCodes.includes(country.code)) {
          return _objectSpread(_objectSpread({}, country), {}, {
            isSelected: true
          });
        }

        return _objectSpread({}, country);
      });
    }
  } // If no URL country codes but upcoming trip has a country, mark that as selected
  else if (prePopulatedData?.countryCode && prePopulatedData.countryCode.length > 0) {
    initialCountryData = initialCountryData.map(country => {
      if (prePopulatedData.countryCode.includes(country.code)) {
        return _objectSpread(_objectSpread({}, country), {}, {
          isSelected: true
        });
      }

      return _objectSpread({}, country);
    });
  } else if (upcomingTrip?.countryCode) {
    initialCountryData = initialCountryData.map(country => {
      if (country.code === upcomingTrip.countryCode) {
        return _objectSpread(_objectSpread({}, country), {}, {
          isSelected: true
        });
      }

      return _objectSpread({}, country);
    });
  }

  return initialCountryData;
};
/**
 * Processes country data based on query parameters and upcoming trip data
 * This function is server-side compatible and can be used in both client and server contexts
 * @param countryList - Array of country objects from the travel form info
 * @param queryParams - Query parameters object containing countries, startDate, endDate, segment, etc.
 * @param upcomingTrip - Upcoming trip data containing countryCode
 * @returns Object containing processed countryData and popularCountryData
 */

const processCountryDataFromQuery = (countryList, queryParams, upcomingTrip, countryCode) => {
  if (!countryList || !Array.isArray(countryList)) {
    return {
      countryData: [],
      popularCountryData: []
    };
  }

  const selectedCountries = queryParams?.countries || countryCode;
  let selectedCountryCodes;

  if (selectedCountries) {
    selectedCountryCodes = selectedCountries.split(",");
  } else if (upcomingTrip?.countryCode) {
    selectedCountryCodes = Array.isArray(upcomingTrip.countryCode) ? upcomingTrip.countryCode : [upcomingTrip.countryCode];
  } // Map countries with selected state


  let totalCountryData = countryList.map(data => {
    if (selectedCountryCodes && Array.isArray(selectedCountryCodes) && selectedCountryCodes.includes(data.code)) {
      return _objectSpread(_objectSpread({}, data), {}, {
        isSelected: true
      });
    }

    return _objectSpread({}, data);
  }); // Handle exclusive country selection

  const isExclusiveCountrySelected = totalCountryData.find(item => item.isExclusiveSelection && item.isSelected);
  totalCountryData = totalCountryData.map(country => {
    if (isExclusiveCountrySelected) {
      return country.isExclusiveSelection ? _objectSpread({}, country) : _objectSpread(_objectSpread({}, country), {}, {
        isSelected: false,
        isDisabled: true
      });
    } else if (totalCountryData.some(item => item.isSelected)) {
      return country.isExclusiveSelection ? _objectSpread(_objectSpread({}, country), {}, {
        isDisabled: true
      }) : _objectSpread({}, country);
    }

    return _objectSpread({}, country);
  }); // Handle region codes

  const selectedRegionCodes = totalCountryData.filter(data => data.isSelected && data.type === "REGION").map(data => data.code);
  selectedRegionCodes.forEach(code => {
    totalCountryData = totalCountryData.map(country => {
      if (country.regionCodes && country.regionCodes.includes(code)) {
        return _objectSpread(_objectSpread({}, country), {}, {
          isDisabled: true
        });
      }

      return _objectSpread({}, country);
    });
  }); // Filter and sort popular country data

  let popularCountryData = totalCountryData.filter(country => country.isSelected || country.isPopular);
  popularCountryData = [...(popularCountryData || []).filter(country => country.isSelected && !country.isDisabled), ...(popularCountryData || []).filter(country => country.isDisabled), ...(popularCountryData || []).filter(country => !country.isSelected && !country.isDisabled)];
  return {
    countryData: totalCountryData,
    popularCountryData: popularCountryData
  };
};

/***/ }),

/***/ 90758:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Ys": () => (/* binding */ generateChatConfigFromURL)
/* harmony export */ });
/* unused harmony exports getSearchContextFromURL, createSearchContext */
// Interface for location details
// Interface for date time details
// Interface for search context input parameters
// Interface for the complete search context object

/**
 * Extracts search context data from URL query parameters
 */
const getSearchContextFromURL = () => {
  // Check if we're on the client side
  if (false) {}

  const queryParams = new URLSearchParams(window.location.search); // Extract countries - take the first country as the primary destination

  const countries = queryParams.get("countries");
  const primaryCountry = countries ? countries.split(",")[0] : undefined; // Extract dates (they come as Unix timestamps in string format)

  const startDateStr = queryParams.get("startDate");
  const endDateStr = queryParams.get("endDate");
  const travellers = queryParams.get("travellers"); // Build the search context parameters

  const searchContextParams = {}; // Set destination info if available

  if (primaryCountry) {
    searchContextParams.countryCode = primaryCountry;
  }

  if (travellers) {
    searchContextParams.count = parseInt(travellers);
  } // Set date info if available


  if (startDateStr) {
    searchContextParams.fromDateTime = {
      ts: parseInt(startDateStr),
      // Convert to milliseconds if needed
      zone: ""
    };
  }

  searchContextParams.profile = "PERSONAL";

  if (endDateStr) {
    searchContextParams.toDateTime = {
      ts: parseInt(endDateStr),
      // Convert to milliseconds if needed
      zone: ""
    };
  }

  return searchContextParams;
};
/**
 * Creates a search context object based on the provided parameters
 */

const createSearchContext = (params = {}) => {
  const searchContext = {}; // Add destination details if provided

  if (params.countryCode) {
    searchContext.to = {
      locusV2Id: "",
      locusV2Type: "",
      countryCode: params.countryCode || "",
      locus: {
        country: params.countryCode || ""
      }
    };
  } // Add date time details if provided


  if (params.fromDateTime) {
    searchContext.fromDateTime = params.fromDateTime;
  }

  if (params.toDateTime) {
    searchContext.toDateTime = params.toDateTime;
  } // Add profile if provided


  if (params.profile) {
    searchContext.profile = params.profile;
  }

  if (params.count) {
    searchContext.pax = [{
      count: params.count
    }];
  }

  return searchContext;
};
/**
 * Generates the complete chat configuration with auto-extracted URL params
 */

const generateChatConfigFromURL = (pageName, prevPageName) => {
  const searchContextParams = getSearchContextFromURL();
  const searchContext = createSearchContext(searchContextParams);
  return {
    context: {
      lob: "INSURANCE",
      lobCategory: "INSURANCE",
      view: pageName,
      project: "insurance_chatbot",
      prevPage: prevPageName
    },
    contextMetadata: {
      pageContext: {
        lob: "INSURANCE",
        lobCategory: "INSURANCE",
        pageName: pageName,
        prevPageName: prevPageName
      },
      searchContext: searchContext
    },
    expertMetadata: {}
  };
}; // Type exports for external usage

/***/ }),

/***/ 81175:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "C": () => (/* binding */ ErrorScreen)
/* harmony export */ });
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(97729);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2784);
/* harmony import */ var _tm_insurance_analytics__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(83636);
/* harmony import */ var _tm_server_utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(2349);
/* harmony import */ var _tm_ui_widgets__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(87109);
/* harmony import */ var _tm_ui_hoc__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(99234);
/* harmony import */ var _tm_insurance_analytics_xdm__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(50354);
/* harmony import */ var _tm_isomorphic_utils__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(44928);
/* harmony import */ var ___WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(58048);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(52322);












const analytics = (0,_tm_insurance_analytics__WEBPACK_IMPORTED_MODULE_2__/* .getAnalytics */ .I)();
const ErrorScreen = ({
  error,
  trackError = false,
  pageName,
  statusCode
}) => {
  (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(() => {
    if (trackError && pageName && error && typeof error !== "string") {
      analytics?.trackPageLoadErrorEvent({
        pageName,
        actionType: "page_load_error",
        error: `${error?.message?.title}|
                  ${error?.message?.description}`
      });
      const pageNameAnalytics = (0,_tm_insurance_analytics_xdm__WEBPACK_IMPORTED_MODULE_6__.getPageNameAnalytics)(pageName);
      (0,_tm_insurance_analytics_xdm__WEBPACK_IMPORTED_MODULE_6__.initializeErrorPageTracking)({
        page_context: {
          page_name: pageNameAnalytics,
          page_type: pageNameAnalytics === "landing" ? "landing" : "funnel",
          funnel_step: pageNameAnalytics === "landing" ? "landing" : pageNameAnalytics
        },
        event_detail: {
          event_value: "error",
          event_name: "error",
          event_type: "action"
        },
        error_details_list: [{
          message: `${error?.message?.title}|
                    ${error?.message?.description}`,
          code: error?.code || statusCode?.toString(),
          source: "error_screen",
          severity: "P2"
        }]
      });
    }
  }, [error, pageName, trackError]);
  const title = typeof error !== "string" && error?.message?.title || "Sorry!";
  const description = typeof error !== "string" && error?.message?.description || "We are having trouble communicating with the servers. Please try again.";
  const icon = typeof error !== "string" && error?.message?.icon || "https://tripmoneycmsimgak.mmtcdn.com/img/error_Img_1e80a42832.svg";
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.Fragment, {
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)((next_head__WEBPACK_IMPORTED_MODULE_0___default()), {
      "data-test-id": "ErrorScreen-Head",
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)("title", {
        "data-test-id": "ErrorScreen-title",
        children: "Tripmoney Error"
      })
    }), (0,_tm_ui_widgets__WEBPACK_IMPORTED_MODULE_4__/* .withDeviceAndThemeProvider */ .OM)((0,_tm_ui_hoc__WEBPACK_IMPORTED_MODULE_5__.withPartnerInsuranceHeader)( /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)(___WEBPACK_IMPORTED_MODULE_8__/* .ErrorPage */ .mf, {
      title: title,
      info: description,
      errorImg: icon,
      headerComponent: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.Fragment, {}),
      "data-test-id": "ErrorScreen-ErrorPage"
    })), (0,_tm_server_utils__WEBPACK_IMPORTED_MODULE_3__/* .akamaiGetDevice */ .tZ)({}), {
      pageTheme: _tm_isomorphic_utils__WEBPACK_IMPORTED_MODULE_7__.PARTNER.MMT
    })]
  });
};

/***/ }),

/***/ 58048:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "SV": () => (/* reexport */ ErrorBoundary),
  "mf": () => (/* reexport */ ErrorPage),
  "Cs": () => (/* reexport */ ErrorScreen/* ErrorScreen */.C)
});

// UNUSED EXPORTS: ErrorImg, ErrorPageStyle

// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../libs/utility/src/lib/analytics/index.ts + 7 modules
var analytics = __webpack_require__(11508);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/ui-container/ErrorBoundary/index.tsx




class ErrorBoundary extends react.Component {
  constructor(props) {
    super(props);
    this.state = {
      hasError: false
    };
  }

  static getDerivedStateFromError(error) {
    // Update state so the next render will show the fallback UI.
    return {
      hasError: true,
      error
    };
  }

  componentDidCatch(error, errorInfo) {
    try {
      if (true) {
        const page_name = typeof window?.location?.pathname === "string" ? window.location.pathname : "unknown";
        const payload = {
          message: error?.message ?? String(error),
          name: error?.name ?? "Error",
          stack: error?.stack ?? "",
          componentStack: errorInfo?.componentStack ?? ""
        };
        (0,analytics/* pdtLog */.b8)({
          event_name: "error_boundary_caught",
          event_value: JSON.stringify(payload),
          page_name,
          event_id: `error_boundary:${page_name}:${payload.message}`
        });
      }
    } catch {// never throw from error boundary
    }

    console.error("componentDidCatch", error);
  }

  render() {
    if (this.state.hasError) {
      // You can render any custom fallback UI
      const error = this.state.error.getErrorMessage ? this.state.error.getErrorMessage() : this.state.error;
      return this.props.onError?.(error) || /*#__PURE__*/(0,jsx_runtime.jsx)(ErrorScreen/* ErrorScreen */.C, {
        error: error,
        "data-test-id": "ErrorBoundary-ErrorScreen"
      });
    }

    return this.props.children;
  }

}
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js
var styled_components_browser_esm = __webpack_require__(82740);
// EXTERNAL MODULE: ../../libs/isomorphic-utils/src/index.ts + 7 modules
var src = __webpack_require__(44928);
// EXTERNAL MODULE: ../../libs/ui/src/lib/static/utils/index.tsx
var utils = __webpack_require__(84576);
// EXTERNAL MODULE: ../../libs/utility/src/lib/theme/colors/index.ts
var colors = __webpack_require__(77809);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/ui-container/Header404/index.style.ts


const LandingHeader = styled_components_browser_esm/* default.header.withConfig */.ZP.header.withConfig({
  displayName: "indexstyle__LandingHeader",
  componentId: "sc-18byzfg-0"
})(["height:80px;position:fixed;top:0;width:100%;z-index:1;color:", ";z-index:40;& .displayNone{display:none;}"], colors/* WHITE_COLOR.60 */.Y[60]);
const LandingHeaderWrap = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "indexstyle__LandingHeaderWrap",
  componentId: "sc-18byzfg-1"
})(["width:1200px;margin:0 auto;display:flex;align-items:center;justify-content:space-between;height:80px;position:relative;"]);
const TMLogo = styled_components_browser_esm/* default.a.withConfig */.ZP.a.withConfig({
  displayName: "indexstyle__TMLogo",
  componentId: "sc-18byzfg-2"
})(["width:140px;height:40px;flex-shrink:0;"]);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/ui-container/Header404/index.tsx



/* istanbul ignore next */




const Header = () => {
  if (!(0,src.isOnServer)()) {
    const toHome = () => {
      window.location.href = "/";
    };

    return /*#__PURE__*/(0,jsx_runtime.jsx)(LandingHeader, {
      "data-test-id": "Header-LandingHeader",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(LandingHeaderWrap, {
        "data-test-id": "Header-LandingHeaderWrap",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(TMLogo, {
          "data-test-id": "Header-TMLogo",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)("img", {
            src: (0,utils/* isHostMakemytrip */.Ho)() ? "https://tripmoneycmsimgak.mmtcdn.com/img/mmt_logo_007ad76964.png" : "https://tripmoneycmsimgak.mmtcdn.com/img/gi_logo_1_dd53c8c777.svg",
            alt: "Blue mmt logo",
            onClick: toHome
          })
        })
      })
    });
  }

  return /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
};

/* harmony default export */ const Header404 = (Header);
// EXTERNAL MODULE: ../../libs/ui/src/lib/static/components/index.tsx + 12 modules
var components = __webpack_require__(48359);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/ui-container/Image/utils.ts
/* istanbul ignore next */
const generateSourceSetImageUrl = (cdnUrlWidths, imgUrl, width) => {
  let imgWidths = cdnUrlWidths;
  if (!imgWidths || !Array.isArray(imgWidths) || imgWidths.length === 0) imgWidths = [width, width * 2, width * 3];
  return imgWidths.map(width => `${imgUrl}?im=Resize=(${width}) ${width}w`).join(",");
};
;// CONCATENATED MODULE: ../../libs/ui/src/lib/ui-container/Image/index.tsx



const Image = ({
  src,
  width,
  height,
  alt = "",
  loading = "lazy",
  className = "",
  id = "",
  cdnUrlWidths = [],
  sizes = ""
}) => {
  if (!src || !width || !height) {
    return null;
  }

  if (src.endsWith(".svg")) {
    return /*#__PURE__*/(0,jsx_runtime.jsx)("img", {
      src: src,
      loading: loading,
      alt: alt,
      className: className,
      id: id,
      width: width,
      height: height,
      "data-test-id": "Image"
    });
  }

  const srcsetUrl = generateSourceSetImageUrl(cdnUrlWidths, src, parseInt(width));
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("picture", {
    "data-test-id": "Image-picture",
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("source", {
      "data-testid": "testID",
      srcSet: srcsetUrl,
      sizes: sizes ? sizes : width,
      "data-test-id": "Image-source"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("img", {
      src: src,
      loading: loading,
      alt: alt,
      className: className,
      id: id,
      width: width,
      height: height
    })]
  });
};
// EXTERNAL MODULE: ../../libs/utility/src/lib/css/Global.ts
var Global = __webpack_require__(42874);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/ui-container/ErrorPage/index.tsx








const ErrorImg = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "ErrorPage__ErrorImg",
  componentId: "lynp6-0"
})(["width:230px;height:230px;margin-bottom:16px;align-self:center;"]);
const ErrorPageStyle = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "ErrorPage__ErrorPageStyle",
  componentId: "lynp6-1"
})(["display:flex;flex-direction:column;justify-content:center;align-items:center;height:100vh;width:100vw;"]);
const ErrorPage = ({
  errorImg,
  title,
  info,
  errorEvent,
  headerComponent,
  button1,
  button2
}) => {
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [headerComponent || /*#__PURE__*/(0,jsx_runtime.jsx)(Header404, {
      "data-test-id": "ErrorPage-Header"
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)(ErrorPageStyle, {
      "data-test-id": "ErrorPage-ErrorPageStyle",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(ErrorImg, {
        "data-test-id": "ErrorPage-ErrorImg",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(Image, {
          src: errorImg,
          width: "230",
          height: "230",
          alt: "Error",
          "data-test-id": "ErrorPage-Image"
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(components.H3Tag, {
        color: Global/* theme.blackText */.rS.blackText,
        "data-test-id": "ErrorPage-H3Tag",
        children: title
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(components.ParaTag, {
        textAlign: "center",
        color: Global/* theme.greyText */.rS.greyText,
        fontSize: "md",
        lineHeight: "32px",
        "data-test-id": "ErrorPage-ParaTag",
        children: info
      }), button1 && /*#__PURE__*/(0,jsx_runtime.jsx)(components.LandingButtonWhite, {
        customTitle: button1,
        customWidth: "100%",
        margin: "32px 0 0",
        "data-test-id": "ErrorPage-LandingButtonWhite"
      }), button2 && /*#__PURE__*/(0,jsx_runtime.jsx)(components.LandingButtonWhite, {
        customTitle: button2,
        customWidth: "100%",
        margin: "32px 0 0",
        "data-test-id": "ErrorPage-LandingButtonWhite"
      })]
    })]
  });
};
// EXTERNAL MODULE: ../../libs/ui/src/lib/ui-container/ErrorScreen/index.tsx
var ErrorScreen = __webpack_require__(81175);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/ui-container/index.ts




/***/ }),

/***/ 65071:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* unused harmony export Ui */
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(82740);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(52322);

/* eslint-disable-next-line */


const StyledUi = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "ui__StyledUi",
  componentId: "sc-1t9d56n-0"
})(["color:pink;"]);
function Ui() {
  return /*#__PURE__*/_jsx(StyledUi, {
    "data-test-id": "StyledUi",
    children: /*#__PURE__*/_jsx("h1", {
      children: "Welcome to Ui!"
    })
  });
}
/* unused harmony default export */ var __WEBPACK_DEFAULT_EXPORT__ = ((/* unused pure expression or super */ null && (Ui)));

/***/ }),

/***/ 45763:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ({"src":"//jsak.mmtcdn.com/tripmoney/apps/insurance-seo-pages/_next/static/media/BlogIcon.56d04790.svg","height":21,"width":20});

/***/ }),

/***/ 67167:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ({"src":"//jsak.mmtcdn.com/tripmoney/apps/insurance-seo-pages/_next/static/media/CitiesIcon.c19a3538.svg","height":19,"width":20});

/***/ }),

/***/ 2703:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ({"src":"//jsak.mmtcdn.com/tripmoney/apps/insurance-seo-pages/_next/static/media/FollowIcon.4a0bda04.svg","height":20,"width":20});

/***/ }),

/***/ 32770:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ({"src":"//jsak.mmtcdn.com/tripmoney/apps/insurance-seo-pages/_next/static/media/MmtInitiative.3f9ab9c4.png","height":56,"width":652,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAABCAYAAADjAO9DAAAAKUlEQVR4nGP8+/WrOBMX16evmzf7/n3w0JovN6f076dPQky8vH8ZgAAAJNgPEW2QH28AAAAASUVORK5CYII=","blurWidth":8,"blurHeight":1});

/***/ }),

/***/ 60582:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ({"src":"//jsak.mmtcdn.com/tripmoney/apps/insurance-seo-pages/_next/static/media/QuickLinks.db19e1dd.svg","height":21,"width":20});

/***/ }),

/***/ 17766:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ({"src":"//jsak.mmtcdn.com/tripmoney/apps/insurance-seo-pages/_next/static/media/twitterIcon.c163d894.png","height":53,"width":58,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAHCAMAAAACh/xsAAAAYFBMVEUlJSUFBQUAAAD////7+/vs6+zc3NzZ2dm0s7QAAAD////7+/vn5+fm5ubl5OXQ0NG+vr62tra0tLWwsLCmpqaLiotzc3Q3Nzc1NTUrKiskJCUiIiIbGxsUFBQODg4AAACkAQV1AAAACnRSTlPm5ub+/v7+/v7+oMtKbgAAADxJREFUeNoNwYcBgCAQBMETIy/mHHD771JmlDknl4jtZQrzJV+XTZFXXixmra2IszfrbsQ+hPEgiu8BIj9b4gPJAqifVwAAAABJRU5ErkJggg==","blurWidth":8,"blurHeight":7});

/***/ })

}]);